export const translations = {
  'de': {
    // de
    '(Use minimum 8 characters. The characters #, ?, % are not allowed)': '(Mindestens 8 Zeichen verwenden. Die Zeichen #, ?, % sind nicht erlaubt)',
    'Checking email...': 'E-Mail wird überprüft...',
    'Valid email, you can register your account with this email.': 'Gültige E-Mail, Sie können Ihr Konto mit dieser E-Mail registrieren.',
    'Please enter a valid email address.': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    'Check the email spelling and try again.': 'Überprüfen Sie die Schreibweise der E-Mail und versuchen Sie es erneut.',
    'This email has a registration in progress.': 'Für diese E-Mail läuft bereits eine Registrierung.',
    'Click to receive verification email.': 'Klicken Sie hier, um die Bestätigungs-E-Mail zu erhalten.',
    'This account was deactivated.': 'Dieses Konto wurde deaktiviert.',
    'Click to receive a new verification email and reactivate it.': 'Klicken Sie hier, um eine neue Bestätigungs-E-Mail zu erhalten und es zu reaktivieren.',
    'This email is already registered with an active account.': 'Diese E-Mail ist bereits mit einem aktiven Konto registriert.',
    'Click to log in': 'Klicken Sie hier, um sich anzumelden',
    'or': 'oder',
    'Click to receive password reset instructions': 'Klicken Sie hier, um Anweisungen zum Zurücksetzen des Passworts zu erhalten',
    'This email is not valid or is not registered.': 'Diese E-Mail ist ungültig oder nicht registriert.',
    'Click to register': 'Klicken Sie hier, um sich zu registrieren',
    'We were unable to continue with this account.': 'Wir können mit diesem Konto nicht fortfahren.',
    'Please contact our support team at': 'Bitte wenden Sie sich an unser Support-Team unter',
    'We could not verify this email right now. Please try again in a few moments.': 'Wir konnten diese E-Mail im Moment nicht überprüfen. Bitte versuchen Sie es in Kürze erneut.',
    'Incorrect email address or password. Please verify your details and try again.': 'E-Mail-Adresse oder Passwort falsch. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.',
    'We could not send the link. Please try again.': 'Der Link konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    'Please wait a moment before requesting another link.': 'Bitte warten Sie einen Moment, bevor Sie einen neuen Link anfordern.',
    'Link sent successfully': 'Link erfolgreich gesendet',
    'Check your email.': 'Überprüfen Sie Ihr E-Mail-Postfach.',
    'We have sent you a new link to complete your registration.': 'Wir haben Ihnen einen neuen Link gesendet, um Ihre Registrierung abzuschließen.',
    'Need help?': 'Brauchen Sie Hilfe?',
    'Contact us': 'Kontaktieren Sie uns',
    "Multiple payment attempts were detected with this card. Please verify that your details are correct before continuing. Check your banking app to confirm your available balance or see if you received a security alert.": "Es wurden mehrere Zahlungsversuche mit dieser Karte festgestellt. Bitte überprüfen Sie, ob Ihre Angaben korrekt sind, bevor Sie fortfahren. Prüfen Sie in Ihrer Banking-App Ihr verfügbares Guthaben oder ob Sie eine Sicherheitswarnung erhalten haben.",
    "Select the payment currency": "Wählen Sie die Zahlungswährung aus",
    "Select the MXN currency on the top right corner if your card was issued in Mexico, or USD if it's an international card. This helps avoid payment rejections.": "Wählen Sie oben rechts die Währung MXN aus, wenn Ihre Karte in Mexiko ausgestellt wurde, oder USD, wenn es sich um eine internationale Karte handelt. Dies hilft, Zahlungsablehnungen zu vermeiden.",
    "Arrival": "Ankunft",
    "Airline": "Fluggesellschaft",
    "Flight no.": "Flugnummer",
    "Arrival Date": "Ankunftsdatum",
    "Arrival Time": "Ankunftszeit",
    "Pickup Time": "Abholzeit",
    "Departure": "Abreise",
    "Departure Date": "Abreisedatum",
    "Departure Time": "Abreisezeit",
    "Flight Arrival Date": "Ankunftsdatum des Fluges",
    "Flight Arrival Time": "Ankunftszeit des Fluges",
    "Flight Departure Date": "Abreisedatum des Fluges",
    "Flight Departure Time": "Abreisezeit des Fluges",
    'An error has occurred, returning to home.': 'Ein Fehler ist aufgetreten, Rückkehr nach Hause.',
    'Please turn your device vertically for a better user experience. Thanks': 'Bitte drehen Sie Ihr Gerät vertikal für eine bessere Benutzererfahrung. Vielen Dank',
    'An error has occurred trying login': 'Ein Fehler ist aufgetreten, Rückkehr nach Hause',
    'Dates': 'Datum',
    '{n} night': '{n} Nacht',
    '{n} nights': '{n} nächte',
    'Destination': 'Ziel',
    'Couldn\'t retrieve budget': '',
    'No Availability for this search': 'Keine Verfügbarkeit für diese Suche',
    'The hotel has no rooms available for the selected dates. If you wish, you can try other dates, search again for another hotel or destination, or contact our call center.': 'Das Hotel hat für die ausgewählten Daten keine Zimmer verfügbar. Wenn Sie möchten, können Sie andere Daten ausprobieren, erneut nach einem anderen Hotel oder Reiseziel suchen oder unser Callcenter kontaktieren.',
    'The budget link contains errors': 'Der Budgetlink enthält Fehler',
    'Please review and fix the following errors from the link': 'Bitte überprüfen und beheben Sie die folgenden Fehler aus dem Link',
    'Loading': 'Wird geladen',
    'Checking your budget': '',
    'Need more time?': 'Sie brauchen mehr Zeit?',
    'We keep for you the same price for 24 hrs.': 'Wir respektieren den Preis und unterliegen der Verfügbarkeit für 24 Stunden.',
    'No questions asked!': 'Wir behalten für Sie den gleichen Preis für 24 Stunden. Keine Hektik!',
    'See Terms and Conditions': 'Terms & Bedingungen',
    'Lock this price': 'Sperren Sie diesen Preis',
    '1 Adult': 'Erwachsene',
    '{n} Adults': 'Erwachsene',
    '1 Child': 'Kinder',
    '{n} Children': 'Kinder',
    '1 Infant': 'Kleinkinder',
    '{n} Infants': 'Kleinkinder',
    'Saved on': 'Gespeichert am',
    'Check  In': 'Einchecken',
    'Rooms': 'Räume',
    'Check Out': 'Auschecken',
    'Guests': 'Gäste',
    'Rate': 'Bewertung',
    'Fee': 'Art zu bezahlen',
    'Total Price': 'Gesamtpreis',
    'Name': 'Name',
    'E-mail': 'Email',
    'We will send you an E-mail to guarantee your spot for 24hrs': 'Wir werden Ihnen eine E-Mail senden, um Ihren Platz für 24 Stunden zu garantieren',
    'This information will not be used for promotional purposes': 'Diese Informationen werden nicht für Werbezwecke verwendet',
    'Send': 'Senden',
    'Wait a moment, please...': 'Einen Moment bitte...',
    'Loading booking...': 'Buchung wird geladen...',
    'Error': 'Error',
    'Sorry, we could not retrieve your booking. Please, contact the hotel.': 'Leider konnten wir Ihre Buchung nicht abrufen. Bitte kontaktieren Sie das Hotel.',
    'Booking details': 'Buchungsdetails',
    'Hotel': 'Hotel',
    'Status': 'Status',
    'Email': 'Email',
    'Amount': 'Menge',
    'Cancellation fee': 'Stornogebühr',
    'An error happened while cancelling your booking.': 'Beim Stornieren Ihrer Buchung ist ein Fehler aufgetreten.',
    'Please, write a reason...': 'Bitte schreiben Sie einen Grund...',
    'Yes, cancel this booking': 'Ja, diese Buchung stornieren',
    'No, I don\'t want to cancel': 'Nein, ich möchte nicht stornieren',
    'Booking was cancelled correctly.': 'Buchung wurde korrekt storniert.',
    'This booking can not be cancelled.': 'Diese Buchung kann nicht storniert werden.',
    'Tell us your reason for cancelling': 'Teilen Sie uns Ihren Kündigungsgrund mit',
    'This is needed to complete your cancellation': 'Dies ist erforderlich, um Ihre Stornierung abzuschließen',
    'Guaranteed online best price!': 'Garantierter Online-Bestpreis!',
    'Total price': 'Gesamtpreis',
    '* taxes included': '* Steuern inbegriffen',
    'Validating...': 'Bestätigen...',
    'Please enter your {loyalty} Code.': 'Bitte geben Sie Ihren {loyalty}-Code ein.',
    'Not a Valid Code': 'Kein gültiger Code',
    'Please enter your sandosSMARTagents.com referral code if you are already a member. If not, register now.': 'Bitte geben Sie Ihren sandosSMARTagents.com-Empfehlungscode ein, wenn Sie bereits Mitglied sind. Wenn nicht, registrieren Sie sich jetzt.',
    'Description': 'Beschreibung',
    'Same as user registration': 'Wie Benutzerregistrierung',
    'Last name': 'Nachname',
    "Second last name": "Zweiter Nachname",
    'Middle Name': 'Zweiter Vorname',
    'Country / Region*': 'Land / Region*',
    'Telephone (mobile number preferred)': 'Telefonnummer (Mobilnummer bevorzugt)',
    'Telephone': 'Telefonnummer',
    'Address': 'Adresszeile',
    'City': 'Ort',
    'Zip code': 'PLZ',
    'E-mail address': 'E-Mail-Adresse',
    'Confirm e-mail address': 'E-Mail-Adresse bestätigen',
    'Client e-mail address': 'E-Mail-Adresse des Kunden',
    'Confirm client e-mail address': 'E-Mail-Adresse des Kunden bestätigen',
    'Comments': 'Bemerkungen',
    'Estimated arrival time*': 'Voraussichtliche Ankunftszeit*',
    'Card Type': 'Kartentyp',
    'Card number': 'Kartennummer',
    'Card holder': 'Kartenhalter',
    'CVC': 'CVC',
    'Expiry month*': 'Ablaufmonat',
    'Expiry year*': 'Ablaufjahr',
    'Your sandosSMARTagents.com referral code:': 'Ihr sandosSMARTagents.com-Empfehlungscode:',
    'I accept the': 'Ich akzeptiere die',
    'Terms & Conditions': 'Allgemeinen Geschäftsbedingungen',
    'member': 'mitglied',
    'YES!': 'JA!',
    'NO!': 'NEIN!',
    '{loyalty} Code here:': '{loyalty} Code hier:',
    'I am a travel agent booking on behalf of my clients': 'Ich bin ein Reisebüro und buche im Namen meiner Kunden',
    'I want to receive exclusive benefits and news by email': 'Ich möchte exklusive Vorteile und Neuigkeiten per E-Mail erhalten',
    'Please select your {fieldName}': 'Bitte wählen Sie Ihren {fieldName} aus',
    'Back': 'Zurück',
    'Book now': 'Buchen Sie jetzt',
    'Save your price for 24hrs': 'SPEICHERN SIE PREIS 24 STUNDEN!',
    'Budget Sent': 'Budget gesendet',
    'Budget Error': 'Budgetfehler',
    'Budget sent correctly. You will receive an email with a link to access it': 'Budget korrekt gesendet. Sie erhalten eine E-Mail mit einem Link, um darauf zuzugreifen',
    'Sorry, your budget could not be saved. Please try again or contact our Call Center for assistance': 'Ihr Budget konnte leider nicht gespeichert werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unser Call Center, um Unterstützung zu erhalten',
    'You have 24 hours to confirm your reservation without changes in both availability and the initial price.': 'Sie haben 24 Stunden Zeit, Ihre Reservierung zu bestätigen, ohne Änderungen in der Verfügbarkeit und der ursprüngliche Preise.',
    'During that time, we will send you an e-mail with all the data you have saved and a link so you can continue with your reservation.': 'In diesem Zeitraum, schicken wir Ihnen eine E-Mail mit den Daten, die sie gespeichert haben und einem Link, damit Sie Ihre Reservierung fortsetzen können.',
    'If after 24 hours you have not formalized your reservation, both the price and its availability could change.': 'Falls Sie die Reservierung nach 24 Stunden nicht abgeschlossen haben, können sich Preis und Verfügbarkeit ändern.',
    'Please, select your payment method': 'Bitte wählen Sie Ihre Zahlungsmethode',
    'Enter your details, you\'re almost done!': 'Gib deine Daten ein, jetzt bist du fast da!',
    'Online payment will take place on the next page through a secure portal.': 'Die Online-Zahlung erfolgt auf der nächsten Seite über ein sicheres Portal.',
    'This rate has no payment method available, please choose another rate.': 'Für diesen Tarif ist keine Zahlungsmethode verfügbar, bitte wählen Sie einen anderen Tarif.',
    'Updating available payment methods, please wait...': 'Aktualisieren der verfügbaren Zahlungsmethoden, bitte warten...',
    'When would you like to pay?': 'Wann möchten Sie bezahlen?',
    'Send an email with the Payment link to the customer': 'Senden Sie eine E-Mail mit dem Zahlungslink an den Kunden',
    'Fill in these missing fields to continue:': 'Füllen Sie diese fehlenden Felder aus, um fortzufahren:',
    'Please accept Terms and Conditions': 'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen',
    'Please, make sure both emails are the same.': 'Bitte stellen Sie sicher, dass beide E-Mails gleich sind.',
    'Please review your e-mail address': 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
    'This card has expired': 'Diese Karte ist abgelaufen',
    'Card Number Invalid': 'Kartennummer ungültig',
    'Card Type Invalid': 'Kartentyp ungültig',
    '{fieldName} is a required field': '{fieldName} ist ein Pflichtfeld',
    '{fieldName} should be at least {length} characters long': '{fieldName} sollte mindestens {length} Zeichen lang sein',
    '{fieldName} must be {length} characters long at most': '{fieldName} darf höchstens {length} Zeichen lang sein',
    'Incorrect data, check the {fieldName}': 'Falsche Daten, überprüfen Sie {fieldName}',
    'Please, review this field. Incorrect format.': 'Bitte überprüfen Sie dieses Feld. Falsches Format.',
    'Check this field. Don\'t use numbers or special characters.': 'Überprüfen Sie dieses Feld. Verwenden Sie keine Zahlen oder Sonderzeichen.',
    'Please review your phone number': 'Bitte überprüfen Sie Ihre Telefonnummer',
    'Your booking is being confirmed': 'Ihre Buchung wird bestätigt',
    'Please wait while we confirm your booking': 'Bitte warten Sie, während wir Ihre Buchung bestätigen',
    'Sorry, your booking could not be confirmed': 'Ihre Buchung konnte leider nicht bestätigt werden',
    'If the problem persists, please take a screenshot and contact the hotel.': 'Wenn das Problem weiterhin besteht, machen Sie bitte einen Screenshot und kontaktieren Sie das Hotel.',
    'One moment, please. You are being redirected to the chosen payment page.': 'Einen Moment bitte. Sie werden auf die gewählte Zahlungsseite weitergeleitet.',
    'Enter your member email or Loyalty Number here.': 'Geben Sie Ihren Benutzernamen oder Ihre E-Mail-Adresse ein oder Sandos4u-Code.',
    '* Redeem coins to obtain discounts up to ': '',
    'Hotel results could not be loaded': 'Hotelergebnisse konnten nicht geladen werden',
    'Hotel was returned without rooms': 'Hotel wurde ohne Zimmer zurückgegeben',
    'Remove all rooms': 'Alle Zimmer entfernen',
    'Continue': 'Fortsetzen',
    'CONTINUE': 'FORTSETZEN',
    'Please select your rooms': 'Bitte wählen Sie Ihre Zimmer aus',
    'child': 'Kind',
    'children': 'Kinder',
    'years': 'Jahre',
    'adult': 'Erwachsene',
    'adults': 'Erwachsene',
    'Cart is updating...': 'Warenkorb wird aktualisiert...',
    '(Coins redeemed)': 'Sie brauchen mehr Zeit?',
    'There was an error updating your cart': 'Beim Aktualisieren Ihres Einkaufswagens ist ein Fehler aufgetreten',
    'The occupancy of the room could not be updated': 'Die Belegung des Zimmers konnte nicht aktualisiert werden',
    'No more than 5 rooms can be added to the basket': 'Es können nicht mehr als 5 Zimmer in den Warenkorb gelegt werden',
    'The room could not be added': 'Das Zimmer konnte nicht hinzugefügt werden',
    'Show Calendar': 'Kalender anzeigen',
    'Occupancy below min paxes': 'Belegung unter min paxes',
    'Update': 'Aktualisieren',
    'infants': 'Säuglinge',
    'hide details': 'Details ausblenden',
    'show details': 'Details anzeigen',
    '{items} in basket': '{Artikel} im Warenkorb',
    'Please correct the price to select the room': 'Bitte korrigieren Sie den Preis, um das Zimmer auszuwählen',
    'Adding...': 'Hinzufügen ...',
    'Added': 'Hinzugefügt',
    'Added ✔': 'Hinzugefügt ✔',
    'Select': 'Wählen',
    'Not available: Minimum stay - {nights} nights': 'Nicht verfügbar: Mindestaufenthalt - {nights} Nächte',
    'Not available: {reason}': 'Nicht verfügbar: {Grund}',
    'Rate code: {code}': 'Preiscode: {code}',
    'There was an error updating the room occupancy': 'Beim Aktualisieren der Zimmerbelegung ist ein Fehler aufgetreten',
    'person': 'Person',
    'persons': 'Personen',
    'Max.': 'Máx.',
    'see details': 'Einzelheiten anzeigen',
    'From': 'Von',
    'No availability with the details you selected': 'Keine Verfügbarkeit mit den von Ihnen ausgewählten Details',
    'Sorry, but there is no availability for the hotel and dates you selected.': 'Es tut uns leid, aber es gibt keine Verfügbarkeit für das von Ihnen ausgewählte Hotel und die von Ihnen ausgewählten Daten.',
    'Minimum stay {n} nights': 'Mindestaufenthalt {n} Nächte',
    'Distance': 'Entfernung: {d}',
    'Please check our other hotels - the hotel you requested has no availability': 'Bitte überprüfen Sie unsere anderen Hotels - das von Ihnen angefragte Hotel hat keine Verfügbarkeit',
    'Sorry, no availability was found in nearby hotels': 'Es wurden leider keine Verfügbarkeiten in Hotels in der Nähe gefunden',
    'We are checking availability in nearby hotels': 'Wir prüfen die Verfügbarkeit in Hotels in der Nähe',
    'Sorry, the hotel you requested has no availability': 'Das von Ihnen angefragte Hotel hat leider keine Verfügbarkeit',
    'Availability in hotels': 'Verfügbarkeit in anderen Hotels',
    'Availability in other hotels': 'Verfügbarkeit in anderen Hotels',
    'Minimum of nights': 'Mindestanzahl Nächte',
    'Not available': 'Nicht verfügbar',
    'Selected': 'Ausgewählt',
    'Omit restrictions and proceed to rooms': 'Lassen Sie die Einschränkungen weg und gehen Sie zu den Zimmern',
    'Hotel Calendar': 'Hotelkalender',
    'Your last search returned no results. Adjust the stay dates using the calendar below': 'Ihre letzte Suche ergab keine Ergebnisse. Passen Sie die Aufenthaltsdaten mithilfe des Kalenders unten an',
    'Latest search was for': 'Letzte Suche war nach',
    'nights from': 'Nächte von',
    'to': 'zu',
    'Check availability': 'Verfügbarkeit prüfen',
    'Add': 'Hinzufügen',
    'Guest {n}': 'Gast {n}',
    'Age {age}': 'Alter {Alter}',
    'Second last name': 'Zweiter Nachname',
    'Room {n}': 'Zimmer {n}',
    'Your message was sent correctly': 'Ihre Nachricht wurde korrekt gesendet',
    'Your message could not be sent to the hotel': 'Ihre Nachricht konnte nicht an das Hotel gesendet werden',
    'Submit': 'Einreichen',
    'Write your message to the hotel': 'Schreiben Sie Ihre Nachricht an das Hotel',
    'contact the hotel': 'Kontaktieren Sie das Hotel',
    'view policies': 'Richtlinien anzeigen',
    'You can also find bookable transfers in the email we just sent you': 'Buchbare Transfers finden Sie auch in der E-Mail, die wir Ihnen gerade gesendet haben',
    'Retrieving your booking...': 'Ihre Buchung abrufen...',
    'Booking Summary': 'Buchungsübersicht',
    'We are sorry, but your booking could not be retrieved. Please, contact the hotel for assistance.': 'Es tut uns leid, aber Ihre Buchung konnte nicht abgerufen werden. Bitte wenden Sie sich an das Hotel, um Hilfe zu erhalten.',
    'Try again': 'Versuchen Sie es nochmal',
    'We are sorry, your booking has pending payments': 'Es tut uns leid, Ihre Buchung hat ausstehende Zahlungen',
    'This means that the payment for your booking did not complete correctly.': 'Dies bedeutet, dass die Zahlung für Ihre Buchung nicht korrekt abgeschlossen wurde.',
    'Please, contact our Call Center for assistance.': 'Bitte wenden Sie sich an unser Call Center, um Hilfe zu erhalten.',
    'Go to payment page': 'Zur Zahlungsseite gehen',
    'Cancel your booking': 'Stornieren Sie Ihre Buchung',
    'Affiliate number': 'Partnernummer',
    '{loyalty} customer code': '{loyalty}-Kundencode',
    'Access only valid for reservations done at Sandos.com and Call Center': 'Zugang nur gültig für Reservierungen auf Sandos.com und im Call Center',
    'Booking reference': 'Buchungsreferenz',
    'We could not find this booking': 'Wir konnten diese Buchung nicht finden',
    'One moment, please...': 'Einen Moment bitte...',
    'Customer link': 'Kundenlink',
    'Send a link for an upfront payment for this booking': 'Senden Sie einen Link für eine Vorauszahlung für diese Buchung',
    'Forward Voucher': 'Gutschein weiterleiten',
    'Sending voucher...': 'Gutschein versenden...',
    'Voucher sent successfully': 'Gutschein erfolgreich versendet',
    'This booking has no outstanding payments': 'Diese Buchung hat keine ausstehenden Zahlungen',
    'Reservation details': 'Reservierungsdetails',
    'Reservation Details': 'Reservierungsdetails',
    'Just one moment, please...': 'Einen Moment bitte...',
    'Proceed to the payment system': 'Weiter zum Zahlungssystem',
    'Select your payment method': 'Wählen Sie eine Bezahlart',
    'Sorry, the payment upfront cannot be done now. Please try later': 'Die Vorauszahlung ist derzeit leider nicht möglich. Bitte versuchen Sie später nochmal',
    'This booking cannot be paid upfront': 'Diese Buchung kann nicht im Voraus bezahlt werden',
    'General Conditions': 'Allgemeine Bedingungen',
    'Loading hotel policies...': 'Hotelrichtlinien werden geladen...',
    'discount': 'Rabatt',
    'applied': 'Angewendet',
    'Adults only': 'Nur für Erwachsene',
    'Selected currency amounts': 'Ausgewählte Währungsbeträge',
    'Room {num} selection': '',
    'Board': 'Board',
    'Different rates or boards have been selected': '',
    'Would you like to keep the original rate and board, or change to those of Room 2?': '',
    'You can also change your selection later': '',
    'Keep original selection': '',
    'Use room 2 selection': '',
    'Please review your selection': 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
    'change {roomType}': 'Zuletzt verfügbar {roomType}!',
    'select {roomType} {n}': '',
    'per night': 'pro Nacht',
    'total price': 'Gesamtpreis',
    'Clear selection': '',
    'Adding rooms...': 'Originalauswahl beibehalten...',
    'Choose this solution': 'Die Sitzung schließen',
    'OR': '',
    'Customize your solution': 'Kundenlink',
    'Your customized solution': 'Ihre maßgeschneiderte Lösung',
    'Add an Extra Night and Receive a {discount}% Extra Long Stay Discount! Book now!': 'Fügen Sie eine zusätzliche Nacht hinzu und erhalten Sie einen Rabatt von {discount}% für extra lange Aufenthalte! Buchen Sie jetzt!',
    'Ok! Let\'s change it': 'OK! Lassen Sie es uns ändern',
    'What is included': 'Was ist enthalten',
    'Extra cost': 'Extrakosten',
    'Key selling points': 'Wichtige Verkaufspunkte',
    'View gallery': 'Galerie ansehen',
    'Applied Promocode': 'Angewandter Promocode',
    '{quota} {roomTypes} left': '{quota} {roomTypes} übrig',
    'No availability': 'Keine Verfügbarkeit',
    'Last available {roomType}!': 'Zuletzt verfügbar {roomType}!',
    'Only {quota} {roomTypes} left': 'Nur noch {quota} {roomTypes} übrig',
    '<span>From </span><b class=\'price-value\'>{amount}</b><span> per night</span>': '<span>Von</span><b class=price-value"">{amount}</b><span>pro Nacht</span>',
    'Adults Only': 'Nur für Erwachsene',
    'Suite Inclusions': 'Suite-Inklusivleistungen',
    'All rooms': 'Alle Zimmer',
    'Recommended': 'EmpfohlenPreis niedrig bis hoch',
    'Price: Low to High': 'Preis niedrig bis hoch',
    'Price: High to Low': 'Preis: Hoch bis Niedrig',
    'View results by': 'Ergebnisse anzeigen von',
    'Sort by': 'Sortieren nach',
    'View rates in': 'Preise anzeigen in',
    'Invalid Promo Code: Enter a different code, make sure is written with CAPITAL LETTERS or continue with your booking.': 'Ungültiger Aktionscode: Geben Sie einen anderen Code ein, vergewissern Sie sich, dass er in GROSSBUCHSTABEN geschrieben ist, oder fahren Sie mit Ihrer Buchung fort.',
    'Select Room Type for Room ': '',
    'Other Rooms Available': '',
    'Invalid Promo Code: Enter a different code or continue with your booking.': 'Ungültiger Aktionscode: Geben Sie einen anderen Code ein oder fahren Sie mit Ihrer Buchung fort.',
    'Free cancellation': 'Kostenfreie Stornierung',
    'Cancellation conditions': 'Stornobedingungen',
    'Off': 'Aus',
    'Long Stay': 'Langer Aufenthalt',
    'Best Rate': 'Bester Preis',
    'Adding rooms ...': 'Originalauswahl beibehalten...',
    'Select best rate': 'Bester Preis',
    'total': 'gesamt',
    'Best rate': 'Bester Preis',
    'Room 360º': 'Raum 360º',
    'Room Floor Plan': '',
    'Room video': 'Zimmervideo',
    'Congratulations! Good choice!': 'Herzliche Glückwünsche! Gute Wahl!',
    'You are about to book a room': 'Sie sind dabei, ein Zimmer zu buchen',
    'Which includes among other amenities and services:': 'Dazu gehören unter anderem Annehmlichkeiten und Dienstleistungen:',
    '{n} people are checking this hotel': '{n} Personen überprüfen dieses Hotel',
    'Book': 'Buch',
    'We use cookies to personalize content and ads, improve your user experience, and to analyze our traffic.': 'Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Ihre Benutzererfahrung zu verbessern und unseren Datenverkehr zu analysieren.',
    'We also share information about your use of our website with our social media, advertising, and analytics partners.': 'Wir geben auch Informationen über Ihre Nutzung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter.',
    'Continue if you agree, or read more about our use of cookies here.': 'Fahren Sie fort, wenn Sie damit einverstanden sind, oder lesen Sie hier mehr über unsere Verwendung von Cookies.',
    'Apply': 'Anwenden',
    'Configure': 'Konfigurieren',
    'More info': 'Mehr Info',
    'Ok, I agree': 'Ok, ich stimme zu',
    'Analysis cookies': 'Analyse-Cookies',
    'Advertising cookies': 'Werbe-Cookies',
    'Personalization cookies': 'Personalisierungs-CookiesObligatorische Cookies',
    'Compulsory cookies': 'Obligatorische Cookies',
    'These cookies allow us to analyze and measure how you use the website to improve browsing.': 'Diese Cookies ermöglichen es uns, zu analysieren und zu erfassen, wie Sie die Website nutzen, um das Surfen zu verbessern.',
    'Advertising companies use these cookies to publish adverts that match your interests.': 'Werbeunternehmen verwenden diese Cookies, um Anzeigen zu veröffentlichen, die Ihren Interessen entsprechen.',
    'These cookies allow us to analyze your user profile and use of the website to give you a personalized experience.': 'Diese Cookies ermöglichen es uns, Ihr Benutzerprofil und die Nutzung der Website zu analysieren, um Ihnen ein personalisiertes Erlebnis zu bieten.',
    'These cookies are essential for the website to work correctly.': 'Diese Cookies sind für das ordnungsgemäße Funktionieren der Website unerlässlich.',
    'Ages': 'Alter',
    'Children': 'Kinder',
    'Ages under': 'Alter unter',
    'Infants': 'Kleinkinder',
    'Adults': 'Erwachsene',
    'Edit': 'Bearbeiten',
    'Save': 'Speichern',
    'This booking is already cancelled': 'Diese Buchung ist bereits storniert',
    'When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).': 'Beim Check-out wird dem {chain}-Mitglied, das die Reservierung vorgenommen hat, eine Rückzahlung in {chain}-Münzen auf der Grundlage des Prozentsatzes seiner Mitgliedsstufe, berechnet auf den betrag des Aufenthalts (ohne Steuern), gutgeschrieben.',
    'Hello {customer}, your reservation is {bookStatus}': 'Hallo {customer}, Ihre Reservierung ist {bookStatus}',
    'Thank you for choosing {hotel}': 'Vielen Dank, dass Sie sich für {hotel} entschieden haben',
    'A confirmation e-mail has been sent to this e-mail address:': 'Eine Bestätigungs-E-Mail wurde an diese E-Mail-Adresse gesendet:',
    'Click here to register now': 'Klicken Sie hier, um sich jetzt anzumelden',
    'and get 20 extra coins to use during your stay': 'und erhalten Sie 20 zusätzliche Münzen, die Sie während Ihres Aufenthalts verwenden können',
    'Incorrect data, check the {label}': 'Falsche Daten, überprüfen Sie das {label}',
    'Coins redeemed': '',
    'PLAN YOUR TRIP': 'PLANEN SIE IHRE REISE',
    '1 night': '1 nacht',
    'Hotel details': 'Hoteldetails',
    'Check-in': 'Einchecken',
    'Check-out': 'Auschecken',
    'Write a message to the hotel': 'Schreiben Sie eine Nachricht an das Hotel',
    'I would like to know...': 'Ich würde gerne wissen...',
    'Loyalty': 'Loyalität',
    'Age': 'Alter',
    'This booking can not be cancelled': 'Diese Buchung kann nicht storniert werden',
    'Cancellation costs': 'Stornokosten',
    'Cancel your reservation': 'Stornieren Sie Ihre Reservierung',
    'Purchase': 'Einkauf',
    'Today': 'Heute',
    'Free cancelation': 'Kostenlose Stornierung',
    'Confirm and close': 'Bestätigen und schließen',
    'We are currently performing maintenance tasks. Please, try again in a few minutes...': 'Wir führen derzeit Wartungsarbeiten durch. Bitte versuchen Sie es in ein paar Minuten noch einmal...',
    '{chain} Hotels & Resorts. All rights reserved': '{chain} Hotels und Resorts. Alle Rechte vorbehalten',
    'Currency': 'Währung',
    'Language': 'Sprache',
    'Close session': 'Die Sitzung schließen',
    'Hello {name}': 'Hallo {name}',
    'Menu': 'Speisekarte',
    'Book your next vacation!': 'Buchen Sie Ihren nächsten Urlaub!',
    'As a {chain} member you can get discounts and benefits in exchange of coins': '',
    'Visit ': '',
    ' to see all benefits': '',
    'Become a member': 'TRETEN SIE DEM PROGRAMM BEI',
    'Login': 'Loge dich ein',
    'Become a member now and get extra coins to use during your stay': 'und erhalten Sie 20 zusätzliche Münzen, die Sie während Ihres Aufenthalts verwenden können',
    'Are you {chain} member?': 'Bist du ein {chain} Mitglied?',
    'Register now and use a {coins} coins gift to apply to your booking': 'Erhalte {coins} Geschenkcoins für die Anmeldung und benutze sie bei der nächsten Reservierung',
    'As a {chain} member you can get discounts in exchange of coins and much more...': 'Als mitglied vom {chain} Programm kannst du Rabatte erhalten im Austauch von Coins',
    'Congratulations!': 'Herzliche Glückwünsche! Gute Wahl!',
    'As a member of Sandos4u this is the maximum price you can have with the accumulation of coins for having previously entrusted your rest days with us that you can confirm in the next step. You can decide if you want to apply them in this or the next one or save them to be able to buy Sandos4u rewards.': '',
    '20 registration coins have been applied to you and this is the result of the new member fee. In the next booking step, you can decide if you want to apply them in this or next, or save them to buy prizes from Sandos4u.': '',
    'or': '',
    '*new members only': '',
    'LOGIN AT {chain}': 'Melden Sie sich bei {chain} an',
    'Password': 'Passwort',
    'Remember me': 'Behalte mich in Erinnerung',
    'Forgotten your password?': 'Hast du dein Passwort vergessen?',
    'Your available Coins': 'Ihre verfügbaren Münzen',
    'Hello': '',
    'Edit coins to use': '',
    '{loyalty} coins': '{Loyalität}-Münzen',
    'will be awarded to you with this booking': 'wird Ihnen mit dieser Buchung gutgeschrieben',
    'Click here to register now ': 'Klicken Sie hier, um sich jetzt anzumelden ',
    'and receive {coins} extra coins to use during your stay.': 'und erhalten Sie {coins} zusätzliche Münzen, die Sie während Ihres Aufenthalts verwenden können.',
    'Your Level': 'Dein Niveau',
    '* Taxes included': '* Steuern inbegriffen',
    'Taxes included': 'Steuern inbegriffen',
    'coins': '',
    'You could use up to {maxAvailDiscountCoins} coins from a total {maxCoins} from your {name} account to get an extra {maxAvailDiscountPercent}%': 'Sie können bis zu {maxAvailDiscountCoins} Coins von insgesamt {maxCoins} Ihres {name}-Kontos verwenden, um zusätzliche {maxAvailDiscountPercent}% zu erhalten',
    '* TOTAL PRICE Taxes included': '* Steuern inbegriffen',
    'LOGIN': 'LOGE DICH EIN',
    'REGISTER': 'REGISTRIEREN',
    'Register at {name} and receive {coins} Coins to Start Saving': 'Registrieren Sie sich bei {name} und erhalten Sie {coins} Münzen, um mit dem Sparen zu beginnen',
    'MY {brand} RATE': 'MEINE {brand} PREISE',
    'Join at {brand} and Start Saving Now': 'Melden Sie sich bei {brand}  an und sparen Sie jetzt',
    'An error has occurred': 'Ein Fehler ist aufgetreten, Rückkehr nach Hause',
    'Forgotten password?': 'Hast du dein Passwort vergessen?',
    'If you have forgotten your password, we will send you a recover email': 'Si olvidaste tu contraseña se enviaremos un email de recuperación',
    'Cancel': 'Absagen',
    'An email has been sent to you to recover your password.': 'Wenn ein Benutzer übereinstimmt, wird eine E-Mail gesendet, mit der Sie Ihr Passwort zurücksetzen können.',
    'Paid amount (with payment method)': 'Bezahlter Betrag (mit Zahlungsmethode)',
    'Paid amount with Loyalty coins': 'Bezahlter Betrag mit Treuemünzen',
    'Paid amount of Loyalty Coins used': 'Bezahlte Menge der verwendeten Treuemünzen',
    'Pending amount to pay in hotel': 'Ausstehender Betrag zur Zahlung im Hotel',
    'Payment method': 'Bezahlverfahren',
    'Loyalty coins used': 'Verwendete Treuemünzen',
    'my area': 'mein Gebiet',
    'catalogue': 'Katalog',
    'how it works': 'wie es funktioniert',
    'payment concepts': 'de zahlungskonzepte',
    'Your wallet': 'Deine Geldbörse',
    'Both emails does not mismatch': 'Beide E-Mails stimmen nicht überein',
    'Both passwords does not mismatch': 'Beide passwort stimmen nicht überein',
    'I want to be a member of Sandos4U': 'Ich möchte Mitglied von Sandos4U werden',
    'I have read and accept the': 'I have read and accept the',
    'and the': 'and the',
    'Privacy Policy': 'Privacy Policy',
    'A user with the provided email already exists': 'Der Benutzername oder die Email existiert bereits',
    'Invalid email address. Please check and try again.': 'Ungültige E-Mail-Adresse. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.',
    'Last name': 'Nachname',
    'Middle name': 'Zweiter Vorname',
    'Repeat email': 'Bestätige die Email',
    'Confirm password': 'Passwort bestätigen',
    '{dateIn} to {dateOut}': '{dateIn} bis {dateOut}',
    'Sorry, but there are errors in your search. Please, check the parameters and try again.': 'Es tut uns leid, aber Ihre Suche enthält Fehler. Bitte überprüfen Sie die Parameter und versuchen Sie es erneut.',
    'Checking availability for your booking:': 'Verfügbarkeit für Ihre Buchung prüfen:',
    'Minimum stay {minStay} nights': 'Mindestaufenthalt {minStay} Nächte',
    'For your better experience, the minimum stay of this hotel is {minStay} days': 'Für eine bessere Erfahrung beträgt der Mindestaufenthalt in diesem Hotel {minStay} Tage',
    'We have adjusted it for you. Do you want to have a look?': 'Wir haben es für Sie angepasst. Willst du reinschauen?',
    'I\'ll do it myself': 'Ich werde es selbst tun',
    'OK, show me': 'OK anzeigen',
    'Loading details from the Share link...': 'Details vom Teilen-Link werden geladen...',
    'Sorry, we could not load the details from the Share link': 'Entschuldigung, wir konnten die Details aus dem Share-Link nicht laden',
    'Copied!': 'Kopiert!',
    'Copy link': 'Link kopieren',
    'downloading PDF ...': 'PDF herunterladen...',
    'download as PDF': 'Als PDF herunterladen',
    'Download Client Voucher PDF': 'Kunden-Gutschein als PDF herunterladen',
    'Download Agency Voucher PDF': 'Agentur-Gutschein als PDF herunterladen',
    'You have chosen a net rate. This means that your commission is already automatically included in the public rate, so you will not have to take any additional steps to receive it.': 'Sie haben einen Nettotarif gewählt. Das bedeutet, dass Ihre Provision bereits automatisch im öffentlichen Tarif enthalten ist, sodass Sie keine zusätzlichen Schritte unternehmen müssen, um sie zu erhalten.',
    'You have chosen a public rate. In this case, you will need to arrange your commission directly with the Sandos team in order to receive payment.': 'Sie haben einen öffentlichen Tarif gewählt. In diesem Fall müssen Sie Ihre Provision direkt mit dem Sandos-Team vereinbaren, um die Auszahlung zu erhalten.',
    'Email is repeated': 'E-Mail wird wiederholt',
    'Invalid email': 'Ungültige E-Mail',
    'Please add at least one e-mail address': 'Bitte fügen Sie mindestens eine E-Mail-Adresse hinzu',
    'Add email': 'E-Mail hinzufügen',
    'Sending...': 'Wird gesendet ...',
    'Send by mail': 'Per E-Mail senden',
    'Enter one or more email addresses': 'Geben Sie eine oder mehrere E-Mail-Adressen ein',
    'Share with more friends': 'Mit mehr Freunden teilen',
    'DONE': 'ABGESCHLOSSEN',
    'The information you wanted to share has been emailed to :': 'Die Informationen, die Sie teilen möchten, wurden per E-Mail an folgende Adresse gesendet:',
    'Email Sent': 'E-Mail gesendet',
    'share with others': 'Mit anderen teilen',
    'Username': 'Nutzername',
    'Have you forgotten your password?': 'Hast du dein Passwort vergessen?',
    'Please check your email inbox with the link to reset your password': 'Bitte überprüfen Sie Ihren E-Mail-Posteingang mit dem Link zum Zurücksetzen Ihres Passworts',
    'Sorry, your username could not be verified': 'Ihr Benutzername konnte leider nicht bestätigt werden',
    'You are already logged in': 'Sie sind bereits eingeloggt',
    'Back to login': 'Zurück zur Anmeldung',
    'Enter your username or email': 'Geben Sie Ihren Benutzernamen oder Ihre E-Mail-Adresse ein',
    'If a user matches, an email will be sent that will allow you to reset your password': 'Wenn ein Benutzer übereinstimmt, wird eine E-Mail gesendet, mit der Sie Ihr Passwort zurücksetzen können',
    'Email / Username': 'E-Mail / Benutzername',
    'Reset password': 'Passwort zurücksetzen',
    'Your password has been updated': 'Ihr Passwort wurde aktualisiert',
    'Your password could not be reset, please try again': 'Ihr Passwort konnte nicht zurückgesetzt werden, bitte versuchen Sie es erneut',
    'Choose your new password': 'Wählen Sie Ihr neues Passwort',
    'Repeat your new password': 'Wiederholen Sie Ihr neues Passwort',
    'Call Center': 'Call Center',
    'infant': 'Säugling',
    'Opening Hours': 'Öffnungszeiten',
    'For bookings or more information dial ': 'Für Buchungen oder weitere Informationen wählen Sie ',
    'or contact: ': 'oder wenden Sie sich an: ',
    'Extras': 'Extras',
    'Transportation': 'Transport',
    'Tours and activities': 'Touren und Aktivitäten',
    'Transportation cost': 'Transportkosten',
    'One way': 'Einfache Fahrt',
    'Round trip': 'Rundfahrt',
    'Call Center Customer Code': 'Callcenter-Kundencode',
    'Please enter a valid email.': 'Bitte geben Sie eine gültige Email-Adresse ein.',
    'You have a {new_member_discount_percentage}% discount from the total cost of the booking': 'Sie erhalten einen Rabatt von {new_member_discount_percentage}% auf die Gesamtkosten der Buchung',
    '% Discount': '% Rabatt',
    'Total Price:': 'Gesamter Preis:',
    'Register at {name} to get a {new_member_discount_percentage}% on your 1st booking': 'Registrieren Sie sich bei {name} um eine 10% Rabatt in seiner 1. Reserve',
    'REGISTER NOW ': 'JETZT ANMELDEN ',
    'TO GET A': 'UM EINE',
    '{percentage}% DISCOUNT ': '{percentage}% RABATT ',
    'ON YOUR 1ST BOOKING': 'IN SEINER 1. RESERVE',
    'REGISTER NOW to get a {percentage}% discount on your 1st booking': 'REGISTRIEREN SIE SICH JETZT, um {percentage}% Rabatt auf Ihre erste Buchung zu erhalten',
    'Stay': 'Aufenthalt',
    'Board type': 'Board-Typ',
    'Board Type': 'Board-Typ',
    'Rooms and Extras': 'Zimmer und Extras',
    'Final Price': 'Endgültiger Preis',
    'Blue': 'Blau',
    'Gold': 'Gold',
    'Nights': 'Nächte',
    'Bookings': 'Buchungen',
    'in the last 2 years': 'in den letzten 2 Jahren',
    'in the last year': 'im letzten Jahr',
    'Room 0': 'Zimmer 0',
    'Type': 'Typ',
    '*Once the reservation is booked, please check your confirmation email to finish setting up your transportation.': '*Sobald die Reservierung gebucht ist, überprüfen Sie bitte Ihre Bestätigungs-E-Mail, um die Einrichtung Ihres Transports abzuschließen.',
    'You have not selected all the rooms yet...': 'Sie haben noch nicht alle Räume ausgewählt...',
    'People': 'Personen',
    'Use Coins': 'Verwenden Münzen',
    'Change Search': 'Suche ändern',
    'Register and': 'Registrieren und',
    'Earn 20 Coins': 'Verdiene 20 Münzen',
    'to book your next stay': 'um Ihren nächsten Aufenthalt zu buchen',
    '*(1 Coin = 1 Dollar/Euro)': '*(1 Münze = 1 Dollar/Euro)',
    'Register Now!': 'Jetzt registrieren!',
    'Learn More about': 'Lerne mehr über',
    'Applied to this room': 'Auf diesen Raum angewendet',
    'Note: The final amount of your reservation will be charged in': 'Hinweis: Der Endbetrag Ihrer Reservierung wird in Rechnung gestellt',
    'equivalent to': 'entspricht',
    'Register at {name}': 'Registrieren Sie sich unter {name}',
    'to get a': 'um eine',
    '% discount': '% rabatt',
    'on your 1st booking': 'in seiner 1. reserve',
    'Select Room': 'Wählen Sie Raum',
    'Our best rate options for your reservation': 'Unsere besten Tarifoptionen für Ihre Reservierung',
    'Select your rate': 'Wählen Sie Ihren Tarif',
    'Empty Cart': 'Leerer Warenkorb',
    'Register to get the best member rate on this booking and win coins to use on your next reservation': 'Registrieren Sie sich, um den besten Mitgliedspreis für diese Buchung zu erhalten und Münzen zu gewinnen, die Sie bei Ihrer nächsten Reservierung verwenden können',
    'JOIN SANDOS4U': 'TRETEN SIE SANDOS4U bei',
    'BEST RATE GUARANTEED': 'BESTER PREIS GARANTIERT',
    'Just by being a member you get access to a preferential rate.': 'Allein durch Ihre Mitgliedschaft erhalten Sie Zugang zu einem bevorzugten Tarif.',
    'WIN COINS FOR EACH RESERVATION': 'GEWINNEN SIE MÜNZEN FÜR JEDER RESERVIERUNG.',
    'When you check out you will get Coins that will be added to your account.': 'Beim Auschecken erhalten Sie Münzen, die Ihrem Konto gutgeschrieben werden.',
    'REDEEM YOUR COINS FOR PRIZES AND STAYS': 'LÖSEN SIE IHRE MÜNZEN FÜR AUSZEICHNUNGEN UND AUFENTHALTE EIN',
    'Exchange your coins for incredible prizes.': 'Tauschen Sie Ihre Münzen gegen unglaubliche Preise ein.',
    'Login with your email': 'Melden Sie sich mit Ihrer E-Mail-Adresse an.',
    'Enter': 'Anmelden',
    'Recover password': 'Passwort wiederherstellen',
    'Not a member of Sandos4U yet?': 'Sie noch kein Mitglied von Sandos4U?',
    'Register': 'Registrieren',
    'REGISTER NOW TO GET THE BEST RATE GUARANTEED': 'REGISTRIEREN SIE SICH JETZT, UM DEN BESTEN PREIS GARANTIERT ZU ERHALTEN.',
    'Discount applied': 'Rabatt angewendet',
    '{brand} {loyaltyLevel} Discount': '{brand} {loyaltyLevel}-Rabatt',
    'Coins Redeemed': 'Münzen Eingelöst',
    'Have an account?': 'Haben Sie ein Konto?',
    'Sign in now': 'Melden Sie sich jetzt an',
    '{brand} {loyaltyLevel} RATE': '{brand} {loyaltyLevel} PREIS',
    '{brand} RATE': '{brand} PREIS',
    'The payment has not been completed. Please verify your information and try again.': 'Die Zahlung wurde nicht abgeschlossen. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.',
    'Your Coins': 'Ihre Münzen',
    'FINAL PRICE': 'ENDPREIS',
    'Arrival Flight no.': 'Ankunftsflug Nr.',
    'Departure Flight no.': 'Abflugsflug Nr.',
    'Apply All': 'Alle Anwenden',
    'Available Coins': 'Verfügbare Münzen',
    'Discount': 'Rabatt',
    'Sign up now at': 'Registriere dich jetzt bei',
    'Continue without an account': 'Weiter ohne Konto',
    'Plus': 'Plus',
    'Create Account': 'Konto Erstellen',
    '**1 S4U Coin = $1 {currency_to_use_coins}': '**1 S4U Coin = $1 {currency_to_use_coins}',
    'At the moment of Check-Out': 'Zum Zeitpunkt des Check-Outs',
    '{loyaltyName} Discount': '{loyaltyName} Rabatt',
    '*Approximate amount of Coins': 'Ungefähre Menge an Münzen',
    'Register or log-in Now at {loyalty_name}': 'Jetzt bei {loyalty_name} registrieren oder anmelden',
    'Log-In': 'Anmelden',
    'Hi': 'Hallo',
    'YOUR RESERVATION': 'IHRE RESERVIERUNG',
    'IS': 'IST',
    'HAS BEEN': 'WURDE',
    'CANCELLED': 'STORNIERT',
    'REVOQUED': 'WIDERRUFEN',
    'PENDING': 'AUSSTEHEND',
    'CONFIRMED': 'BESTÄTIGT',
    'On behalf of the Sandos family, we would like to warmly welcome you to {hotel_name}.': 'Im Namen der Sandos-Familie heißen wir Sie herzlich willkommen im {hotel_name}.',
    'We are looking forward to your upcoming visit. Below you will find your reservation details:': 'Wir freuen uns auf Ihren bevorstehenden Besuch. Nachfolgend finden Sie die Details Ihrer Reservierung:',
    "BOOKING DETAILS": "BUCHUNGSÜBERSICHT",
    "Confirmation Number:": "Bestätigungsnummer:",
    "Reservation Status:": "Buchungsstatus:",
    "Total Price:": "Gesamtpreis:",
    "Amount Paid (with payment method):": "Bezahlter Betrag (mit Zahlungsmethode):",
    "Pending Amount to Pay at the Hotel:": "Ausstehender Betrag, der im Hotel zu zahlen ist:",
    "Loyalty Coins Used:": "Verwendete Treuepunkte:",
    "Coins": "Coins",
    "At check-out, SANDOS4U coins will be added to the account of the SANDOS4U Member who made the reservation. The amount will be calculated based on the percentage corresponding to their membership level, applied to the total stay (excluding taxes).": "Bei der Abreise werden SANDOS4U-Punkte dem Konto des SANDOS4U-Mitglieds gutgeschrieben, das die Buchung vorgenommen hat. Die Anzahl der Punkte errechnet sich aus dem Prozentsatz, der der Mitgliedschaftsstufe entspricht, angewendet auf den Gesamtaufenthalt (ohne Steuern).",
    "GUEST INFORMATION": "GASTINFORMATIONEN",
    "Edit": "Bearbeiten",
    "Guest Name:": "Gastname:",
    "Email:": "E-Mail:",
    "Country:": "Land:",
    "Country": "Land",
    "Check-in / Check-out": "Anreise / Abreise",
    "Check-in Time:": "Check-in-Zeit:",
    "Check-out Time:": "Check-out-Zeit:",
    "ROOM DETAILS": "ZIMMERDETAILS",
    "Total:": "Gesamt:",
    "Room": "Zimmer",
    "Room Type:": "Zimmertyp:",
    "Rate:": "Tarif:",
    "Occupants:": "Personen:",
    "Adults": "Erwachsene",
    "children": "Kinder",
    "Plan:": "Verpflegung:",
    "Arrival Date:": "Anreisedatum:",
    "Departure Date:": "Abreisedatum:",
    "Room amount:": "Zimmerpreis:",
    "Room amount (client):": "Zimmerbetrag (Kunde):",
    "Room amount (agent):": "Zimmerbetrag (Agent):",
    "UPGRADES/EXTRAS DETAILS": "UPGRADE-/EXTRAS-DETAILS",
    "(Please inquire at the front desk for more information about available upgrades and extras).": "(Bitte erkundigen Sie sich an der Rezeption nach verfügbaren Upgrades und Extras).",
    "If you have any questions or special requests, please do not hesitate to contact us.": "Wenn Sie Fragen oder besondere Wünsche haben, zögern Sie bitte nicht, uns zu kontaktieren.",
    "We hope you enjoy your stay at {hotel_name}!": "Wir hoffen, Sie genießen Ihren Aufenthalt im {hotel_name}!",
    "Our best rate options for your reservation": "Unsere besten Preise für Ihre Buchung",
    "Is everything correct?": "Ist alles korrekt?",
    "You can check or modify your booking online without needing to register.": "Sie können Ihre Buchung online überprüfen oder ändern, ohne sich registrieren zu müssen.",
    "Cancel your booking": "Buchung stornieren",
    "Change the dates": "Daten ändern",
    "Change your room": "Zimmer wechseln",
    "Request invoice": "Rechnung anfordern",
    "Contact Us": "Kontakt",
    "Call center:": "Callcenter:",
    "Contact the hotel": "Hotel kontaktieren",
    "Remember, you can make changes to this booking anytime.": "Denken Sie daran, Sie können diese Buchung jederzeit ändern.",
    'Select the room you want to edit': 'Wählen Sie das Zimmer aus, das Sie bearbeiten möchten',
    'Pay now to confirm your booking': 'Zahlen Sie jetzt, um Ihre Buchung zu bestätigen',
    'Confirm change': 'Änderung bestätigen',
    'Confirm the changes to apply the update': 'Bestätigen Sie die Änderungen, um das Update anzuwenden',
    'You are editing your reservation': 'Sie bearbeiten Ihre Reservierung',
    'Exit edit mode': 'Bearbeitungsmodus verlassen',
    "We're sorry": "Es tut uns leid",
    'This room is currently unavailable': 'Dieses Zimmer ist momentan nicht verfügbar',
    "Mexico and Others:": "Mexiko und andere:",
    "Spain and Europe:": "Spanien und Europa:",
    "USA:": "USA:",
    "Canada:": "Kanada:",
    "Argentina:": "Argentinien:",
    "Brazil:": "Brasilien:",
    "UK:": "Vereinigtes Königreich:",
    "Rate without taxes": "Preis ohne Steuern",
    "Taxes": "Steuern",
    "Price details": "Preisdetails",
    "Net price": "Netto",
    "Public price": "Brutto",
    "Price": "Preis",
    "Offer applied": "Angebot angewendet",
    "(Price per room per night)": "(Preis pro Zimmer pro Nacht)",
    "Total": "Gesamt",
    "I agree to receive promotions from Sandos4U": "Ich bin damit einverstanden, Werbeaktionen von Sandos4U zu erhalten",
    "Up to {months} months interest-free (with eligible credit cards)": "Bis zu {months} ​​Monate zinsfrei (mit berechtigten Kreditkarten)",
    "INTEREST FREE INSTALLMENTS": "MONATE OHNE ZINSEN",
    "(FOR DETAILS, PLEASE CONSULT YOUR BANK)": "(FÜR WEITERE INFORMATIONEN WENDEN SIE SICH BITTE AN IHRE BANK)",
    "Register Now": "Jetzt Registrieren",
    "Learn More": "Mehr Info",
    "Sandos4u Benefits": "Sandos4U-Vorteile",
    "Date of birth": "Geburtsdatum",
    "All nature experience": "Alles Naturerlebnis"
  },
  'es': {
    '(Use minimum 8 characters. The characters #, ?, % are not allowed)': '(Usa un mínimo de 8 caracteres. Los caracteres #, ?, % no están permitidos)',
    'Checking email...': 'Verificando email...',
    'Valid email, you can register your account with this email.': 'Email válido, puedes registrar tu cuenta con este email.',
    'Please enter a valid email address.': 'Por favor, introduce una dirección de email válida.',
    'Check the email spelling and try again.': 'Revisa la ortografía del email e inténtalo de nuevo.',
    'This email has a registration in progress.': 'Este email tiene un registro en progreso.',
    'Click to receive verification email.': 'Clic para recibir email de verificación.',
    'This account was deactivated.': 'Esta cuenta fue dada de baja.',
    'Click to receive a new verification email and reactivate it.': 'Haz clic para recibir un nuevo correo de verificación y reactivarla.',
    'This email is already registered with an active account.': 'Este email ya está registrado con una cuenta activa.',
    'Click to log in': 'Clic para iniciar sesión',
    'or': 'o',
    'Click to receive password reset instructions': 'Clic para recibir instrucciones de restablecimiento de contraseña',
    'This email is not valid or is not registered.': 'Este email no es válido o no está registrado.',
    'Click to register': 'Clic para registrarte',
    'We were unable to continue with this account.': 'No pudimos continuar con esta cuenta.',
    'Please contact our support team at': 'Por favor, contacta a nuestro equipo de soporte en',
    'We could not verify this email right now. Please try again in a few moments.': 'No pudimos verificar este email en este momento. Inténtalo de nuevo en unos momentos.',
    'Incorrect email address or password. Please verify your details and try again.': 'Correo o contraseña incorrectos. Verifica tus datos e inténtalo de nuevo.',
    'We could not send the link. Please try again.': 'No pudimos enviar el enlace. Inténtalo de nuevo.',
    'Please wait a moment before requesting another link.': 'Espera un momento antes de solicitar otro enlace.',
    'Link sent successfully': 'Enlace enviado exitosamente',
    'Check your email.': 'Revisa tu correo.',
    'We have sent you a new link to complete your registration.': 'Te hemos enviado un nuevo enlace para completar tu registro.',
    'Need help?': '¿Necesitas ayuda?',
    'Contact us': 'Contáctanos',
    "Multiple payment attempts were detected with this card. Please verify that your details are correct before continuing. Check your banking app to confirm your available balance or see if you received a security alert.": "Se han registrado múltiples intentos con esta tarjeta. Verifica que los datos sean correctos antes de continuar. Revisa la app de tu banco para verificar tu saldo disponible o si recibiste alguna alerta de seguridad.",
    "Select the payment currency": "Seleccione la divisa de pago",
    "Select the MXN currency on the top right corner if your card was issued in Mexico, or USD if it's an international card. This helps avoid payment rejections.": "Selecciona la moneda MXN en la esquina superior derecha si tu tarjeta fue emitida en México, o USD si es una tarjeta internacional. Esto ayuda a evitar rechazos en el pago.",
    "Arrival": "Llegada",
    "Airline": "Aerolínea",
    "Flight no.": "N.º de vuelo",
    "Arrival Date": "Fecha de llegada",
    "Arrival Time": "Hora de llegada",
    "Pickup Time": "Hora de recogida",
    "Departure": "Salida",
    "Departure Date": "Fecha de salida",
    "Departure Time": "Hora de salida",
    "Flight Arrival Date": "Fecha de llegada del vuelo",
    "Flight Arrival Time": "Hora de llegada del vuelo",
    "Flight Departure Date": "Fecha de salida del vuelo",
    "Flight Departure Time": "Hora de salida del vuelo",
    'An error has occurred, returning to home.': 'Ha ocurrido un error, volviendo a la página de inicio.',
    'Please turn your device vertically for a better user experience. Thanks': 'Por favor, ponga su dispositivo en vertical para una mejor experiencia de usuario. Gracias',
    'An error has occurred trying login': 'Ha ocurrido un error, volviendo a la página de inicio',
    'Dates': 'Fechas',
    '{n} night': '1 noche',
    '{n} nights': '{n} noches',
    'Destination': 'Destino',
    'Couldn\'t retrieve budget': '',
    'No Availability for this search': 'No hay disponibilidad para esta búsqueda',
    'The hotel has no rooms available for the selected dates. If you wish, you can try other dates, search again for another hotel or destination, or contact our call center.': 'El hotel no tiene habitaciones disponibles para las fechas seleccionadas. Si lo desea, puede probar otras fechas, buscar de nuevo otro hotel o destino, o contactar con nuestro call center.',
    'The budget link contains errors': 'El enlace del presupuesto contiene errores.',
    'Please review and fix the following errors from the link': 'Revise y corrija los errores del enlace',
    'Loading': 'Cargando',
    'Checking your budget': '',
    'Need more time?': '¿Necesitas más tiempo?',
    'We keep for you the same price for 24 hrs.': 'Respetaremos el precio y queda sujeto a disponibilidad durante 24 horas.',
    'No questions asked!': '¡Sin prisas!, te respetamos este precio por 24 horas.',
    'See Terms and Conditions': 'Términos y condiciones',
    'Lock this price': 'Guardar mi presupuesto',
    '1 Adult': 'Adultos',
    '{n} Adults': 'Adultos',
    '1 Child': 'Niños',
    '{n} Children': 'Niños',
    '1 Infant': 'Bebés',
    '{n} Infants': 'Bebés',
    'Saved on': 'Guardado el',
    'Check  In': 'Entrada',
    'Rooms': 'Habitaciones',
    'Check Out': 'Salida',
    'Guests': 'Huéspedes',
    'Rate': 'Tarifa',
    'Fee': 'Forma de pago',
    'Total Price': 'Precio total',
    'Room extras': 'Extras de habitación',
    'Airport - Hotel Transportation': 'Transportación Aeropuerto - Hotel',
    'Name': 'Nombre',
    'E-mail': 'Email',
    'We will send you an E-mail to guarantee your spot for 24hrs': 'Te enviaremos un email para garantizar tu plaza durante 24 horas',
    'This information will not be used for promotional purposes': 'Esta información no será utilizada para fines promocionales',
    'Send': 'Enviar',
    'Wait a moment, please...': 'Un momento, por favor...',
    'Loading booking...': 'Cargando la reserva...',
    'Error': 'Error',
    'Sorry, we could not retrieve your booking. Please, contact the hotel.': 'Lo sentimos, no hemos podido recuperar su reserva. Por favor, contacte con el hotel.',
    'Booking details': 'Detalles de la reserva',
    'Hotel': 'Hotel',
    'Status': 'Estado',
    'Email': 'Correo electrónico',
    'Amount': 'Importe',
    'Cancellation fee': 'Gastos de cancelación',
    'An error happened while cancelling your booking.': 'Se produjo un error mientras se cancelaba su reserva.',
    'Please, write a reason...': 'Por favor, escriba un motivo...',
    'Yes, cancel this booking': 'Sí, quiero cancelar esta reserva',
    'No, I don\'t want to cancel': 'No, no quiero cancelar la reserva',
    'Booking was cancelled correctly.': 'La reserva ha sido cancelada correctamente.',
    'This booking can not be cancelled.': 'Esta reserva no puede ser cancelada.',
    'Tell us your reason for cancelling': '¿Cuál es el motivo de la cancelación?',
    'This is needed to complete your cancellation': 'Tienes que responder para completar tu cancelación',
    'Guaranteed online best price!': '¡Mejor precio online garantizado!',
    'Total price': 'Precio total',
    '* taxes included': '* impuestos incluídos',
    'Validating...': 'Validando...',
    'Please enter your {loyalty} Code.': 'Por favor indique su código {loyalty}',
    'Not a Valid Code': 'El código no es válido',
    'Please enter your sandosSMARTagents.com referral code if you are already a member. If not, register now.': 'Ingrese su código de referencia de sandosSMARTagents.com si ya es miembro. Si no, regístrese ahora.',
    'Description': 'Descripción',
    'Same as user registration': 'Igual que los datos de registro',
    'Last name': 'Apellido',
    "Second last name": "Segundo apellido",
    'Middle Name': 'Segundo nombre',
    'Country / Region*': 'País / región*',
    'Telephone (mobile number preferred)': 'Teléfono (móvil, si es posible)',
    'Telephone': 'Teléfono',
    'Address': 'Dirección',
    'City': 'Ciudad',
    'Zip code': 'Código postal',
    'E-mail address': 'E-mail',
    'Confirm e-mail address': 'Confirmar e-mail',
    'Client e-mail address': 'E-mail del cliente',
    'Confirm client e-mail address': 'Confirmar e-mail del cliente',
    'Comments': 'Comentarios',
    'Estimated arrival time*': 'Hora de llegada estimada*',
    'Card Type': 'Tipo de tarjeta',
    'Card number': 'Número de tarjeta',
    'Card holder': 'Titular',
    'CVC': 'CVC',
    'Expiry month*': 'Mes expiración*',
    'Expiry year*': 'Año expiración*',
    'Your sandosSMARTagents.com referral code:': 'Su código de referencia sandosSMARTagents.com:',
    'I accept the': 'Acepto los',
    'Terms & Conditions': 'Términos y condiciones',
    'member': 'miembro',
    'YES!': '¡Sí!',
    'NO!': '¡No!',
    '{loyalty} Code here:': 'Código {loyalty}:',
    'I am a travel agent booking on behalf of my clients': 'Soy un agente de viajes que reserva en nombre de mis clientes',
    'I want to receive exclusive benefits and news by email': 'Quiero recibir ofertas y noticias exclusivas por email',
    'Please select your {fieldName}': 'Por favor indique {fieldName}',
    'Back': 'Atrás',
    'Book now': 'Reservar',
    'Save your price for 24hrs': '¡GUARDA LOS PRECIOS DURANTE 24 HORAS!',
    'Budget Sent': 'Presupuesto enviado',
    'Budget Error': 'Error de presupuesto',
    'Budget sent correctly. You will receive an email with a link to access it': 'Presupuesto enviado correctamente. Recibirás un email con un enlace para acceder a él',
    'Sorry, your budget could not be saved. Please try again or contact our Call Center for assistance': 'Lo sentimos, pero no hemos podido recuperar su reserva. Por favor, contacte con el hotel.',
    'You have 24 hours to confirm your reservation without changes in both availability and the initial price.': 'Tienes 24 horas para confirmar tu reserva sin cambios tanto en la disponibilidad como en los precios iniciales.',
    'During that time, we will send you an e-mail with all the data you have saved and a link so you can continue with your reservation.': 'Durante ese tiempo, te enviaremos un e-mail con todos los datos que tienes guardados y un enlace para que puedas continuar con tu reserva.',
    'If after 24 hours you have not formalized your reservation, both the price and its availability could change.': 'Si pasadas 24 horas no ha formalizado su reserva, tanto el precio como su disponibilidad podrían cambiar.',
    'Please, select your payment method': 'Por favor, seleccione la tipo de pago',
    'Enter your details, you\'re almost done!': 'Introduce tus datos, ya casi lo tienes!',
    'Online payment will take place on the next page through a secure portal.': 'El pago online se realizará en la siguiente página a través de un portal seguro.',
    'This rate has no payment method available, please choose another rate.': 'Esta tarifa no tiene forma de pago disponible, por favor escoja otra tarifa.',
    'Updating available payment methods, please wait...': 'Cargando métodos de pago disponibles, por favor espere...',
    'When would you like to pay?': '¿Cómo te gustaría pagar?',
    'Send an email with the Payment link to the customer': 'Enviar mail  al cliente con enlace al pago',
    'Fill in these missing fields to continue:': 'Complete los siguientes datos para continuar:',
    'Please accept Terms and Conditions': 'Por favor, acepte los términos y condiciones',
    'Please, make sure both emails are the same.': 'Por favor compruebe que ambas direcciones sean la misma.',
    'Please review your e-mail address': 'Por favor, compruebe su dirección de e-mail',
    'This card has expired': 'La tarjeta ha expirado',
    'Card Number Invalid': 'Número de tarjeta',
    'Card Type Invalid': 'Tipo de tarjeta inválida',
    '{fieldName} is a required field': 'El campo {fieldName} es requerido',
    '{fieldName} should be at least {length} characters long': '{fieldName} debe tener al menos {length} caracteres',
    '{fieldName} must be {length} characters long at most': '{fieldName} debe tener como mucho {length} caracteres',
    'Incorrect data, check the {fieldName}': 'Datos incorrectos, revise el {fieldName}',
    'Please, review this field. Incorrect format.': 'Por favor, revise este campo. Formato incorrecto.',
    'Check this field. Don\'t use numbers or special characters.': 'Comprueba este campo. No uses números o caracteres especiales.',
    'Please review your phone number': 'Por favor, compruebe su número de teléfono',
    'Your booking is being confirmed': 'Su reserva está siendo confirmada',
    'Please wait while we confirm your booking': 'Por favor, espere mientras confirmamos su reserva',
    'Sorry, your booking could not be confirmed': 'Lo sentimos, su reserva no ha podido ser confirmada',
    'If the problem persists, please take a screenshot and contact the hotel.': 'Si el problema persiste, por favor haga una captura y contacte al hotel.',
    'One moment, please. You are being redirected to the chosen payment page.': 'Un momento, por favor. Le estamos redirigiendo al sistema de pago seleccionado.',
    'Enter your member email or Loyalty Number here.': 'Introduzca su email de miembro {loyalty} o Código Loyalty aquí.',
    '* Redeem coins to obtain discounts up to ': '* Canjea coins y obten descuentos de hasta ',
    'Hotel results could not be loaded': 'No se pudieron cargar los resultados del hotel',
    'Hotel was returned without rooms': 'El hotel devuelto no contiene habitaciones',
    'Remove all rooms': 'Limpiar todas',
    'Continue': 'Continuar',
    'CONTINUE': 'CONTINUAR',
    'Please select your rooms': 'Seleccione sus habitaciones',
    'child': 'niño',
    'children': 'niños',
    'years': 'años',
    'adult': 'adulto',
    'adults': 'adultos',
    'Cart is updating...': 'Actualizando cesta...',
    '(Coins redeemed)': '(Coins canjeadas)',
    'There was an error updating your cart': 'Hubo un problema actualizando',
    'The occupancy of the room could not be updated': 'No se pudo actualizar la ocupación',
    'No more than 5 rooms can be added to the basket': 'El máximo de habitaciones es 5',
    'The room could not be added': 'No se pudo añadir la habitación',
    'Show Calendar': 'Mostrar Calendario',
    'Occupancy below min paxes': 'Ocupación inferior a mínima',
    'Update': 'Actualizar',
    'infants': 'bebés',
    'hide details': 'ocultar detalles',
    'show details': 'mostrar detalles',
    '{items} in basket': '{items} en la cesta',
    'Please correct the price to select the room': 'Corrija el precio para seleccionar la habitación',
    'Adding...': 'Añadiendo...',
    'Added': 'Añadido',
    'Added ✔': 'Añadido ✔',
    'Select': 'Seleccione',
    'Not available: Minimum stay - {nights} nights': 'No disponible: Estancia mínima: {nights} noches',
    'Not available: {reason}': 'No disponible: {reason}',
    'Rate code: {code}': 'Código de tarifa: {code}',
    'There was an error updating the room occupancy': 'El cambio de ocupación ha fallado',
    'person': 'persona',
    'persons': 'personas',
    'Max.': 'Máx.',
    'see details': 'ver detalles',
    'From': 'Desde',
    'No availability with the details you selected': 'No se encontró disponibilidad con la información seleccionada',
    'Sorry, but there is no availability for the hotel and dates you selected.': 'Lo sentimos, no hay disponibilidad en el hotel y fechas seleccionadas.',
    'Minimum stay {n} nights': 'Estancia mínima: {n} noches',
    'Distance': 'Distancia',
    'Please check our other hotels - the hotel you requested has no availability': 'Compruebe nuestros otros hoteles - el hotel seleccionado no está disponible',
    'Sorry, no availability was found in nearby hotels': 'Lo sentimos, no se encontró disponibilidad en los hoteles cercanos',
    'We are checking availability in nearby hotels': 'Estamos buscando disponibilidad en hoteles cercanos',
    'Sorry, the hotel you requested has no availability': 'Lo sentimos, no hay disponibilidad en el hotel solicitado',
    'Availability in hotels': 'Disponibilidad en otros hoteles',
    'Availability in other hotels': 'Disponibilidad en otros hoteles',
    'Minimum of nights': 'Mínimo de noches',
    'Not available': 'No disponible',
    'Selected': 'Seleccionado',
    'Omit restrictions and proceed to rooms': 'Omitir restricciones y ver habitaciones',
    'Hotel Calendar': 'Calendario del hotel',
    'Your last search returned no results. Adjust the stay dates using the calendar below': 'La última búsqueda no obtuvo resultados. Ajuste las fechas de estancia usando el calendario inferior',
    'Latest search was for': 'La última búsqueda fue de',
    'nights from': 'noches desde',
    'to': 'hasta',
    'Check availability': 'Comprobar disponibilidad',
    'Add': 'Añadir',
    'Guest {n}': 'Huésped {n}',
    'Age {age}': 'Edad {age}',
    'Second last name': 'Segundo apellido',
    'Room {n}': 'Habitación {n}',
    'Your message was sent correctly': 'Su mensaje ha sido enviado correctamente',
    'Your message could not be sent to the hotel': 'No se pudo enviar su mensaje al hotel',
    'Submit': 'Enviar',
    'Write your message to the hotel': 'Escriba su mensaje para el hotel',
    'contact the hotel': 'contactar con el hotel',
    'view policies': 'ver políticas',
    'You can also find bookable transfers in the email we just sent you': 'También podrá encontrar los traslados reservables en el e-mail que le hemos enviado',
    'Retrieving your booking...': 'Recuperando su reserva...',
    'Booking Summary': 'Resumen de la reserva',
    'We are sorry, but your booking could not be retrieved. Please, contact the hotel for assistance.': 'Lo sentimos, pero no hemos podido recuperar su reserva. Por favor, contacte con el hotel.',
    'Try again': 'Inténtelo de nuevo',
    'We are sorry, your booking has pending payments': 'Lo sentimos, su reserva tiene pagos pendientes',
    'This means that the payment for your booking did not complete correctly.': 'Esto significa que el pago de su reserva no se ha completado correctamente. Por favor, contacte con nuestro Servicio de Atención.',
    'Please, contact our Call Center for assistance.': 'Por favor, contacte con Atención al Cliente.',
    'Go to payment page': 'Acceda a la página de pago',
    'Cancel your booking': 'Cancelar su reserva',
    'Affiliate number': 'Número de  afiliado',
    '{loyalty} customer code': 'Código {loyalty}',
    'Access only valid for reservations done at Sandos.com and Call Center': 'Solo se puede acceder a reservas realizadas en Sandos.com y Call Center',
    'Booking reference': 'Referencia de la reserva',
    'We could not find this booking': 'No hemos podido encontrar la reserva',
    'One moment, please...': 'Un momento, por favor...',
    'Customer link': 'Enlace para el cliente',
    'Send a link for an upfront payment for this booking': 'Enviar un enlace para el pago anticipado de la reserva',
    'Forward Voucher': 'Reenvio Bono',
    'Sending voucher...': 'Enviando bono...',
    'Voucher sent successfully': 'Bono enviado correctamente',
    'This booking has no outstanding payments': 'Esta reserva no tiene pagos pendientes',
    'Reservation details': 'Detalles de la reserva',
    'Reservation Details': 'Detalles de la Reserva',
    'Just one moment, please...': 'Sólo un momento, por favor...',
    'Proceed to the payment system': 'Acceder a la pasarela de pago',
    'Select your payment method': 'Forma de pago',
    'Sorry, the payment upfront cannot be done now. Please try later': 'Lo sentimos, el pago anticipadao no puede realizarse ahora. Inténtelo después',
    'This booking cannot be paid upfront': 'Esta reserva no puede ser pagada anticipadamente',
    'General Conditions': 'Condiciones Generales',
    'Loading hotel policies...': 'Cargando las políticas del hotel...',
    'discount': 'descuento',
    'applied': 'aplicado',
    'Adults only': 'Sólo adultos',
    'Selected currency amounts': 'Importes en divisa seleccionada',
    'Room {num} selection': '',
    'Board': 'Régimen',
    'Different rates or boards have been selected': '',
    'Would you like to keep the original rate and board, or change to those of Room 2?': '',
    'You can also change your selection later': '',
    'Keep original selection': '',
    'Use room 2 selection': '',
    'Please review your selection': 'Por favor, compruebe su dirección de e-mail',
    'change {roomType}': '¡Última {roomType} disponible!',
    'select {roomType} {n}': '',
    'per night': 'por noche',
    'total price': 'precio total',
    'Clear selection': '',
    'Adding rooms...': 'Añadiendo...',
    'Choose this solution': 'Cerrar sesión',
    'OR': '',
    'Customize your solution': 'Enlace para el cliente',
    'Your customized solution': 'Su combinación personalizada',
    'Add an Extra Night and Receive a {discount}% Extra Long Stay Discount! Book now!': 'Reserva una Noche más y obtén un {discount}% de Descuento Adicional. No lo dejes escapar!',
    'Ok! Let\'s change it': 'Vale! Vamos a cambiarlo',
    'What is included': 'Qué se incluye',
    'Extra cost': 'Coste extra',
    'Key selling points': 'Destacados',
    'View gallery': 'Ver galería',
    'Applied Promocode': 'Promocode aplicado',
    '{quota} {roomTypes} left': 'Sólo quedan {quota} {roomType}',
    'No availability': 'Sin disponibilidad',
    'Last available {roomType}!': '¡Última {roomType} disponible!',
    'Only {quota} {roomTypes} left': 'Sólo quedan {quota} {roomTypes}',
    '<span>From </span><b class=\'price-value\'>{amount}</b><span> per night</span>': '<span>Desde </span><b class="price-value">{amount}</b><span> por noche</span>',
    'Adults Only': 'Sólo adultos',
    'Suite Inclusions': 'Qué se incluye',
    'All rooms': 'Todas',
    'Recommended': 'Recomendada',
    'Price: Low to High': 'Precio: Menor a Mayor',
    'Price: High to Low': 'Precio: Mayor a Menor',
    'View results by': 'Ver resultados por',
    'Sort by': 'Ordenar por',
    'View rates in': 'Ver tarifas en',
    'Invalid Promo Code: Enter a different code, make sure is written with CAPITAL LETTERS or continue with your booking.': 'Código de promoción no válido: ingrese un código diferente, asegúrese de que esté escrito con LETRAS MAYÚSCULAS o continúe con su reserva.',
    'Select Room Type for Room ': '',
    'Other Rooms Available': '',
    'Invalid Promo Code: Enter a different code or continue with your booking.': 'Código promocional no válido: Introduce un código diferente o continúa con tu reserva.',
    'Free cancellation': 'Cancelación gratuita',
    'Cancellation conditions': 'Condiciones de cancelación',
    'Off': 'Dto',
    'Long Stay': 'Larga Estancia',
    'Best Rate': 'Mejor tarifa',
    'Adding rooms ...': 'Añadiendo...',
    'Select best rate': 'Mejor tarifa',
    'total': 'en total',
    'Best rate': 'Mejor tarifa',
    'Room 360º': 'Habitación 360º',
    'Room Floor Plan': '',
    'Room video': 'Vídeo de la habitación',
    'Congratulations! Good choice!': '¡Felicidades! ¡Buena elección!',
    'You are about to book a room': 'Estás a punto de reservar una habitación',
    'Which includes among other amenities and services:': 'Que incluye entre otras amenidades y servicios:',
    '{n} people are checking this hotel': '{n} personas están mirando este hotel',
    'Book': 'Reservar',
    'We use cookies to personalize content and ads, improve your user experience, and to analyze our traffic.': 'Usamos cookies para personalizar contenido y anuncios, mejorar su experiencia de usuario y analizar nuestro tráfico.',
    'We also share information about your use of our website with our social media, advertising, and analytics partners.': 'También compartimos información sobre su uso de nuestro sitio web con nuestros socios de redes sociales, publicidad y análisis.',
    'Continue if you agree, or read more about our use of cookies here.': 'Continúe si está de acuerdo, o lea más sobre nuestro uso de cookies aquí.',
    'Apply': 'Guardar Preferencias',
    'Configure': 'Configurar',
    'More info': 'Más info',
    'Ok, I agree': 'Ok Acepto',
    'Analysis cookies': 'Cookies de análisis',
    'Advertising cookies': 'Cookies publicitarias',
    'Personalization cookies': 'Cookies de personalización',
    'Compulsory cookies': 'Cookies Obligatorias',
    'These cookies allow us to analyze and measure how you use the website to improve browsing.': 'Estas cookies nos permiten analizar y medir cómo utiliza el sitio web para mejorar la navegación.',
    'Advertising companies use these cookies to publish adverts that match your interests.': 'Las empresas de publicidad utilizan estas cookies para publicar anuncios que coincidan con sus intereses.',
    'These cookies allow us to analyze your user profile and use of the website to give you a personalized experience.': 'Estas cookies nos permiten analizar su perfil de usuario y el uso del sitio web para brindarle una experiencia personalizada.',
    'These cookies are essential for the website to work correctly.': 'Estas cookies son esenciales para que el sitio web funcione correctamente.',
    'Ages': 'Edades',
    'Children': 'Niños',
    'Ages under': 'Edad menor de',
    'Infants': 'Bebés',
    'Adults': 'Adultos',
    'Edit': 'Editar',
    'Save': 'Guardar',
    'Enhance your Stay': 'Mejora tu estancia',
    'Tours and Activities': 'Tours y Actividades',
    'Passengers': 'Pasajeros',
    'This booking is already cancelled': 'Esta reserva ya está cancelada',
    'When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).': 'Al registro de salida del hotel, se generará a favor del Socio {chain} que haya realizado la reserva un retorno en {chain} Coins en base al porcentaje correspondiente a su membresía calculado sobre el importe de la estancia (sin impuesto).',
    'Hello {customer}, your reservation is {bookStatus}': 'Hola {customer}, su reserva está {bookStatus}',
    'Thank you for choosing {hotel}': 'Gracias por elegir {hotel}',
    'A confirmation e-mail has been sent to this e-mail address:': 'Le hemos enviado un correo de confirmación a esta dirección:',
    'Click here to register now': 'Haga clic aquí para registrarse ahora',
    'and get 20 extra coins to use during your stay': 'y recibir 20 monedas adicionales para usar durante su estancia',
    'Incorrect data, check the {label}': 'Datos incorrectos, revise el {label}',
    'Coins redeemed': 'Coins aplicadas',
    'PLAN YOUR TRIP': 'PLANIFICA TU VIAJE',
    '1 night': '1 noche',
    'Hotel details': 'Detalles del hotel',
    'Check-in': 'Entrada',
    'Check-out': 'Salida',
    'Write a message to the hotel': 'Escriba su mensaje para el hotel',
    'I would like to know...': 'Me gustaría saber...',
    'Loyalty': 'Lealtad',
    'Age': 'Edad',
    'This booking can not be cancelled': 'Esta reserva no puede ser cancelada',
    'Cancellation costs': 'Gastos de cancelación',
    'Cancel your reservation': 'Cancele su reserva',
    'Purchase': 'Compra',
    'Today': 'Hoy',
    'Free cancelation': 'Cancelación gratuita',
    'Confirm and close': 'Confirmar y cerrar',
    'We are currently performing maintenance tasks. Please, try again in a few minutes...': 'Estamos llevando a cabo tareas de mantenimiento. Por favor, intente en unos minutos...',
    '{chain} Hotels & Resorts. All rights reserved': '{chain} Hotels & Resorts. Todos los derechos reservados',
    'Currency': 'Divisa',
    'Language': 'Idioma',
    'Close session': 'Cerrar sesión',
    'Hello {name}': 'Hola {name}',
    'Menu': 'Menú',
    'Book your next vacation!': '¡Reserve sus vacaciones!',
    'As a {chain} member you can get discounts and benefits in exchange of coins': 'Como miembro de {chain} puedes obtener premios y descuentos a cambio de coins',
    'Visit ': 'Visita ',
    ' to see all benefits': ' para ver todos los beneficios',
    'Become a member': 'ÚNETE AL PROGRAMA',
    'Login': 'Inicia Sesión',
    'Become a member now and get extra coins to use during your stay': 'y recibir 20 monedas adicionales para usar durante su estancia',
    'Are you {chain} member?': '¿Eres miembro de {chain}?',
    'Register now and use a {coins} coins gift to apply to your booking': 'Obtén {coins} coins de regalo por registrarte y utilizalos en tu próxima reserva',
    'As a {chain} member you can get discounts in exchange of coins and much more...': 'Como miembro de {chain} puedes conseguir descuentos a cambio de coins',
    'Congratulations!': '¡Enhorabuena!',
    'As a member of Sandos4u this is the maximum price you can have with the accumulation of coins for having previously entrusted your rest days with us that you can confirm in the next step. You can decide if you want to apply them in this or the next one or save them to be able to buy Sandos4u rewards.': 'Como miembro de Sandos4u este es el precio máximo que puedes tener con la acumulación de coins que podrás confirmar en el siguiente paso. Puedes decidir si quieres aplicarlos o guardarlos para poder comprar premios de Sandos4u.',
    '20 registration coins have been applied to you and this is the result of the new member fee. In the next booking step, you can decide if you want to apply them in this or next, or save them to buy prizes from Sandos4u.': 'Se te han aplicado 20 coins de registro y este es el resultado de la tarifa de nuevo miembro. En ',
    'or': 'o',
    '*new members only': '* sólo nuevos miembros',
    'LOGIN AT {chain}': 'INICIA SESIÓN EN {chain}',
    'Password': 'Contraseña',
    'Remember me': 'Recuérdame',
    'Forgotten your password?': '¿Ha olvidado su contraseña?',
    'Your available Coins': 'Tus Coins disponibles',
    'Hello': 'Hola',
    'Edit coins to use': 'Edita las coins a utilizar',
    '{loyalty} coins': 'coins {loyalty}',
    'will be awarded to you with this booking': 'bonificados por esta reserva',
    'Click here to register now ': 'Haga clic aquí para registrarse ahora ',
    'and receive {coins} extra coins to use during your stay.': 'y recibir {coins} monedas adicionales para usar durante su estancia.',
    'Your Level': 'Tu nivel',
    '* Taxes included': '* Impuestos incluidos',
    'Taxes included': 'Impuestos incluidos',
    'coins': 'coins',
    'You could use up to {maxAvailDiscountCoins} coins from a total {maxCoins} from your {name} account to get an extra {maxAvailDiscountPercent}%': 'Puedes usar hasta {maxAvailDiscountCoins} coins del total de {maxCoins} coins de tu cuenta de Sandos4u para obtener el {maxAvailDiscountPercent}% de descuento',
    '* TOTAL PRICE Taxes included': '* impuestos incluídos',
    'LOGIN': 'INICIA SESIÓN',
    'REGISTER': 'ÚNETE',
    'Register at {name} and receive {coins} Coins to Start Saving': 'Únete a {name} y recibe {coins} Coins para empezar a ahorrar',
    'MY {brand} RATE': 'MI TARIFA DE {brand}',
    'Join at {brand} and Start Saving Now': 'Únete a {brand} y empieza a ahorrar',
    'An error has occurred': 'Ha ocurrido un error, volviendo a la página de inicio',
    'Forgotten password?': '¿Ha olvidado su contraseña?',
    'If you have forgotten your password, we will send you a recover email': 'Si has olvidado tú contraseña, te enviamos un email para recuperarla',
    'Cancel': 'Cancelar',
    'An email has been sent to you to recover your password.': 'Si el usuario coincide, le enviaremos un email que le permitirá resetear su contraseña',
    'Paid amount (with payment method)': 'Monto pagado (con método de pago)',
    'Paid amount with Loyalty coins': 'Monto pagado con coins de Loyalty',
    'Paid amount of Loyalty Coins used': 'Monto utilizado de coins Loyalty',
    'Pending amount to pay in hotel': 'Monto pendiente de pago en el hotel',
    'Payment method': 'Método de pago',
    'Loyalty coins used': 'Coins de Loyalty utilizados',
    'my area': 'mi area',
    'catalogue': 'catálogo',
    'how it works': 'Cómo funciona',
    'payment concepts': 'conceptos de pago',
    'Your wallet': 'Tus coins',
    'Both emails does not mismatch': 'Los emails no coinciden',
    'Both passwords does not mismatch': 'Las contraseñas no coinciden',
    'I want to be a member of Sandos4U': 'Quiero ser miembro de Sandos4U',
    'I have read and accept the': 'He leído y acepto los',
    'and the': 'y la',
    'Privacy Policy': 'Política de Privacidad',
    'A user with the provided email already exists': 'El nombre de usuario o email ya existe',
    'Invalid email address. Please check and try again.': 'Correo electrónico inválido. Verifica e inténtalo de nuevo.',
    'Last name': 'Apellido',
    'Middle name': 'Segundo nombre',
    'Repeat email': 'Reintroduce email',
    'Confirm password': 'Confirmar contraseña',
    '{dateIn} to {dateOut}': '{dateIn} a {dateOut}',
    'Sorry, but there are errors in your search. Please, check the parameters and try again.': 'Lo sentimos, pero hay errores en su búsqueda. Por favor, revise los parámetros y vuelva a intentarlo.',
    'Checking availability for your booking:': 'Comprobando la disponibilidad de su reserva:',
    'Minimum stay {minStay} nights': 'Estancia mínima: {minStay} noches',
    'For your better experience, the minimum stay of this hotel is {minStay} days': 'Para una mejor experiencia, la estancia mínima de este hotel es {minStay} dias',
    'We have adjusted it for you. Do you want to have a look?': 'Lo hemos ajustado para usted. ¿Quiere comprobarlo?',
    'I\'ll do it myself': 'Lo haré yo',
    'OK, show me': 'Sí, cambiar',
    'Loading details from the Share link...': 'Cargando los detalles del enlace compartido...',
    'Sorry, we could not load the details from the Share link': 'Lamentablemente, no hemos podido cargar los detalles del enlace compartido',
    'Copied!': '¡Copiado!',
    'Copy link': 'Copiar enlace',
    'downloading PDF ...': 'descargando PDF ...',
    'download as PDF': 'descargar como PDF',
    'Download Client Voucher PDF': 'Descargar Bono De Cliente PDF',
    'Download Agency Voucher PDF': 'Descargar Bono De Agencia PDF',
    'You have chosen a net rate. This means that your commission is already automatically included in the public rate, so you will not have to take any additional steps to receive it.': 'Has elegido una tarifa neta. Esto significa que tu comisión ya está incluida automáticamente en la tarifa pública, por lo que no tendrás que realizar ningún paso adicional para recibirla.',
    'You have chosen a public rate. In this case, you will need to arrange your commission directly with the Sandos team in order to receive payment.': 'Has elegido una tarifa pública. En este caso, deberás gestionar tu comisión directamente con el equipo de Sandos para recibir el pago.',
    'Email is repeated': 'Email repetido',
    'Invalid email': 'Email inválido',
    'Please add at least one e-mail address': 'Por favor agregue al menos una dirección de e-mail',
    'Add email': 'Añadir email',
    'Sending...': 'Enviando...',
    'Send by mail': 'Enviar por email',
    'Enter one or more email addresses': 'Entre una o más direcciones de email',
    'Share with more friends': 'Compartir con más amigos',
    'DONE': 'HECHO',
    'The information you wanted to share has been emailed to :': 'La información que quería compartido se ha enviado a los correos:',
    'Email Sent': 'El email ha sido enviado',
    'share with others': 'compartir con otros',
    'Username': 'Nombre de usuario',
    'Have you forgotten your password?': '¿Ha olvidado su contraseña?',
    'Please check your email inbox with the link to reset your password': 'Por favor, revise su bandeja de entrada para poder resetear su contraseña',
    'Sorry, your username could not be verified': 'Lo sentimos, su nombre no usuario no ha podido ser validado',
    'You are already logged in': 'Ya estás logueado',
    'Back to login': 'Volver a login',
    'Enter your username or email': 'Indique su nombre de usuario o email',
    'If a user matches, an email will be sent that will allow you to reset your password': 'Si el usuario coincide, le enviaremos un email que le permitirá resetear su contraseña',
    'Email / Username': 'Email / Nombre de usuario',
    'Reset password': 'Resetear contraseña',
    'Your password has been updated': 'Su contraseña ha sido actualizada',
    'Your password could not be reset, please try again': 'Su contraseña no ha podido ser reseteada, por favor reinténtelo',
    'Choose your new password': 'Indique su nueva contraseña',
    'Repeat your new password': 'Repita su nueva contraseña',
    'Call Center': 'Call Center',
    'infant': 'bebé',
    'Opening Hours': 'Horarios de apertura',
    'For bookings or more information dial ': 'Para reservas o más información marcar ',
    'or contact: ': 'o contactar: ',
    'Extras': 'Extras',
    'Transportation': 'Transporte',
    'Tours and activities': 'Tours y actividades',
    'Transportation cost': 'Costo de transporte',
    'One way': 'Ida',
    'Round trip': 'Redondo',
    'Call Center Customer Code': 'Call Center Customer Code',
    'Please enter a valid email.': 'Por favor introduzca una dirección de correo electrónico válida.',
    'You have a {new_member_discount_percentage}% discount from the total cost of the booking': 'Tienes un {new_member_discount_percentage}% de descuento sobre el coste total de la reserva',
    '% Discount': '% de descuento',
    'Total Price:': 'Precio Total: ',
    'Register at {name} to get a {new_member_discount_percentage}% on your 1st booking': 'Únete a {name} para obtener un {new_member_discount_percentage}% de descuento en su 1ª reserva',
    'REGISTER NOW ': 'REGÍSTRESE AHORA ',
    'TO GET A': 'PARA OBTENER UN',
    '{percentage}% DISCOUNT ': '{percentage}% DE DESCUENTO ',
    'ON YOUR 1ST BOOKING': 'EN SU 1ª RESERVA',
    'REGISTER NOW to get a {percentage}% discount on your 1st booking': 'REGÍSTRATE AHORA para obtener un {percentage}% de descuento en su 1ª reserva',
    'Stay': 'Estancia',
    'Board type': 'Tipo de régimen',
    'Board Type': 'Tipo de Régimen',
    'Rooms and Extras': 'Habitaciones y Extras',
    'Final Price': 'Precio Final',
    'Blue': 'Blue',
    'Gold': 'Gold',
    'Nights': 'Noches',
    'Bookings': 'Reservas',
    'in the last 2 years': 'en los últimos 2 años',
    'in the last year': 'en el último año',
    'Room 0': 'Habitación 0',
    'Type': 'Tipo',
    '*Once the reservation is booked, please check your confirmation email to finish setting up your transportation.': '*Una vez realizada la reserva, consulte su correo electrónico de confirmación para terminar de configurar su transporte.',
    'You have not selected all the rooms yet...': 'Aún no has seleccionado todas las habitaciones...',
    'People': 'Personas',
    'Use Coins': 'Usar Coins',
    'Change Search': 'Cambiar Búsqueda',
    'Register and': 'Regístrate y',
    'Earn 20 Coins': 'Gana 20 Coins',
    'to book your next stay': 'para reservar tu próxima estancia',
    '*(1 Coin = 1 Dollar/Euro)': '*(1 Coin = 1 Dólar/Euro)',
    'Register Now!': '¡Regístrate ahora!',
    'Learn More about': 'Aprender más acerca de',
    'Applied to this room': 'Aplicado a esta habitación',
    'Note: The final amount of your reservation will be charged in': 'Nota: El monto final de su reserva se cobrará en',
    'equivalent to': 'equivalente a',
    'Register at {name}': 'Únete a {name}',
    'to get a': 'para obtener un',
    '% discount': '% de descuento',
    'on your 1st booking': 'en su 1ª reserva',
    'Select Room': 'Seleccione Habitación',
    'Our best rate options for your reservation': 'Nuestras mejores opciones de tarifas para tu reserva',
    'Select your rate': 'Selecciona tu tarifa',
    'Empty Cart': 'Vacíar Carrito',
    'Register to get the best member rate on this booking and win coins to use on your next reservation': 'Regístrese para obtener la mejor tarifa de miembro en esta reserva y gane coins para usar en su próxima reserva.',
    'JOIN SANDOS4U': 'ÚNETE A SANDOS4U',
    'BEST RATE GUARANTEED': 'MEJOR TARIFA GARANTIZADA',
    'Just by being a member you get access to a preferential rate.': 'Solo por ser miembro accede a una tarifa preferencial.',
    'WIN COINS FOR EACH RESERVATION': 'GANA COINS POR CADA RESERVA',
    'When you check out you will get Coins that will be added to your account.': 'Al hacer checkout obtén Coins que se agregaran a tu cuenta.',
    'REDEEM YOUR COINS FOR PRIZES AND STAYS': 'REDIME TUS COINS POR PREMIOS Y ESTANCIAS',
    'Exchange your coins for incredible prizes.': 'Cambia tus coins por increíbles premios.',
    'Login with your email': 'Entrar con tu correo electrónico',
    'Enter': 'Entrar',
    'Recover password': 'Recuperar contraseña',
    'Not a member of Sandos4U yet?': '¿Aun no eres socio de Sandos4U?',
    'Register': 'Crea tu cuenta',
    'REGISTER NOW TO GET THE BEST RATE GUARANTEED': 'REGÍSTRESE AHORA PARA OBTENER LA MEJOR TARIFA GARANTIZADA',
    'Discount applied': 'Descuento aplicado',
    '{brand} {loyaltyLevel} Discount': 'Descuento {brand} {loyaltyLevel}',
    'Coins Redeemed': 'Coins aplicadas',
    'Have an account?': '¿Tienes una cuenta?',
    'Sign in now': 'Inicia sesión',
    '{brand} {loyaltyLevel} RATE': 'TARIFA {brand} {loyaltyLevel}',
    '{brand} RATE': 'TARIFA {brand}',
    'The payment has not been completed. Please verify your information and try again.': 'El pago no se ha completado. Verifica tu información e intenta nuevamente.',
    'Your Coins': 'Tus Coins',
    'FINAL PRICE': 'PRECIO FINAL',
    'Arrival Flight no.': 'Número de vuelo de llegada',
    'Departure Flight no.': 'Número de vuelo de salida',
    'Apply All': 'Aplicar Todo',
    'Available Coins': 'Coins Disponibles',
    'Discount': 'Descuento',
    'Sign up now at': 'Regístrate ahora en',
    'Continue without an account': 'Continuar sin cuenta',
    'Plus': 'Más',
    'Create Account': 'Crear Cuenta',
    '**1 S4U Coin = $1 {currency_to_use_coins}': '**1 S4U Coin = $1 {currency_to_use_coins}',
    'At the moment of Check-Out': 'Al momento del Check-Out',
    '{loyaltyName} Discount': 'Descuento {loyaltyName}',
    '*Approximate amount of Coins': '*Número aproximado de Coins',
    'Register or log-in Now at {loyalty_name}': 'Regístrate o inicia sesión ahora en {loyalty_name}',
    'Log-In': 'Iniciar sesión',
    'Hi': 'Hola',
    'YOUR RESERVATION': 'SU RESERVACIÓN',
    'IS': 'ESTÁ',
    'HAS BEEN': 'HA SIDO',
    'CANCELLED': 'CANCELADA',
    'REVOQUED': 'REVOCADA',
    'PENDING': 'PENDIENTE',
    'CONFIRMED': 'CONFIRMADA',
    'On behalf of the Sandos family, we would like to warmly welcome you to {hotel_name}.': 'De parte de la familia Sandos, queremos darle una cálida bienvenida a {hotel_name}.',
    'We are looking forward to your upcoming visit. Below you will find your reservation details:': 'Estamos ansiosos por su próxima visita. A continuación, encontrará los detalles de su reservación:',
    "BOOKING DETAILS": "DETALLES DE LA RESERVA",
    "Confirmation Number:": "Número de confirmación:",
    "Reservation Status:": "Estado de la reservación:",
    "Total Price:": "Precio total:",
    "Amount Paid (with payment method):": "Monto pagado (con método de pago):",
    "Pending Amount to Pay at the Hotel:": "Monto pendiente por pagar en el hotel:",
    "Loyalty Coins Used:": "Monedas de fidelidad utilizadas:",
    "Coins": "Coins",
    "At check-out, SANDOS4U coins will be added to the account of the SANDOS4U Member who made the reservation. The amount will be calculated based on the percentage corresponding to their membership level, applied to the total stay (excluding taxes).": "Al momento del check-out, se agregarán monedas SANDOS4U a la cuenta del Miembro SANDOS4U que realizó la reservación. El monto será calculado en base al porcentaje correspondiente a su nivel de membresía, sobre el total de la estancia (sin impuestos).",
    "GUEST INFORMATION": "DATOS DEL HUÉSPED",
    "Edit": "Editar",
    "Guest Name:": "Nombre del huésped:",
    "Email:": "Correo electrónico:",
    "Country:": "País:",
    "Country": "País",
    "Check-in / Check-out": "Entrada / Salida",
    "Check-in Time:": "Hora de check-in:",
    "Check-out Time:": "Hora de check-out:",
    "ROOM DETAILS": "DETALLES DE HABITACIONES",
    "Total:": "Total:",
    "Room": "Habitación",
    "Room Type:": "Tipo de habitación:",
    "Rate:": "Tarifa:",
    "Occupants:": "Ocupantes:",
    "Adults": "Adultos",
    "children": "niños",
    "Plan:": "Plan:",
    "Arrival Date:": "Fecha de llegada:",
    "Departure Date:": "Fecha de salida:",
    "Room amount:": "Monto de la habitación:",
    "Room amount (client):": "Importe habitación (cliente):",
    "Room amount (agent):": "Importe habitación (agente):",
    "UPGRADES/EXTRAS DETAILS": "DETALLES DE MEJORAS/EXTRAS",
    "(Please inquire at the front desk for more information about available upgrades and extras).": "(Por favor, consulte en la recepción para más información sobre mejoras y extras disponibles).",
    "If you have any questions or special requests, please do not hesitate to contact us.": "Si tiene alguna pregunta o solicitud especial, no dude en ponerse en contacto con nosotros.",
    "We hope you enjoy your stay at {hotel_name}!": "¡Esperamos que disfrute su estancia en {hotel_name}!",
    "Our best rate options for your reservation": "Nuestras mejores tarifas para su reservación",
    "Is everything correct?": "¿Está todo correcto?",
    "You can check or modify your booking online without needing to register.": "Puedes revisar o modificar tu reserva en línea sin necesidad de registrarte.",
    "Cancel your booking": "Cancelar tu reserva",
    "Change the dates": "Cambiar las fechas",
    "Change your room": "Cambiar tu habitación",
    "Request invoice": "Solicitar factura",
    "Contact Us": "Contacto",
    "Call center:": "Call center:",
    "Contact the hotel": "Contactar con el hotel",
    "Remember, you can make changes to this booking anytime.": "Recuerda que puedes hacer cambios en esta reserva en cualquier momento.",
    'Select the room you want to edit': 'Selecciona la habitación que deseas editar',
    'Pay now to confirm your booking': 'Pague ahora para confirmar su reserva',
    'Confirm change': 'Confirmar cambio',
    'Confirm the changes to apply the update': 'Confirma los cambios para aplicar la actualización',
    'You are editing your reservation': 'Está editando su reserva',
    'Exit edit mode': 'Salir del modo edición',
    "We're sorry": "Lo sentimos",
    'This room is currently unavailable': 'Por el momento esta habitación no está disponible',
    "Mexico and Others:": "México y otros:",
    "Spain and Europe:": "España y Europa:",
    "USA:": "EE.UU.:",
    "Canada:": "Canadá:",
    "Argentina:": "Argentina:",
    "Brazil:": "Brasil:",
    "UK:": "Reino Unido:",
    "Rate without taxes": "Tarifa sin impuestos",
    "Taxes": "Impuestos",
    "Price details": "Detalles del precio",
    "Price": "Precio",
    "Net price": "Neto",
    "Public price": "Público",
    "Offer applied": "Oferta aplicada",
    "(Price per room per night)": "(Precio por habitación por noche)",
    "Total": "Total",
    "I agree to receive promotions from Sandos4U": "Acepto recibir promociones de Sandos4U",
    "Up to {months} months interest-free (with eligible credit cards)": "Hasta {months} meses sin intereses (con tarjetas participantes)",
    "INTEREST FREE INSTALLMENTS": "MESES SIN INTERESES",
    "(FOR DETAILS, PLEASE CONSULT YOUR BANK)": "(PARA MÁS DETALLES, POR FAVOR CONSULTA CON TU BANCO)",
    "Register Now": "Regístrate Ahora",
    "Learn More": "Más Info",
    "Sandos4u Benefits": "Beneficios Sandos4u",
    "Date of birth": "Fecha de nacimiento",
    "All nature experience": "All nature experience"
  },
  'fr': {
    '(Use minimum 8 characters. The characters #, ?, % are not allowed)': '(Utilisez au minimum 8 caractères. Les caractères #, ?, % ne sont pas autorisés)',
    'Checking email...': "Vérification de l'e-mail...",
    'Valid email, you can register your account with this email.': 'E-mail valide, vous pouvez créer votre compte avec cet e-mail.',
    'Please enter a valid email address.': 'Veuillez saisir une adresse e-mail valide.',
    'Check the email spelling and try again.': "Vérifiez l'orthographe de l'e-mail et réessayez.",
    'This email has a registration in progress.': 'Cet e-mail a une inscription en cours.',
    'Click to receive verification email.': "Cliquez pour recevoir l'e-mail de vérification.",
    'This account was deactivated.': 'Ce compte a été désactivé.',
    'Click to receive a new verification email and reactivate it.': 'Cliquez pour recevoir un nouvel e-mail de vérification et le réactiver.',
    'This email is already registered with an active account.': 'Cet e-mail est déjà associé à un compte actif.',
    'Click to log in': 'Cliquez pour vous connecter',
    'or': 'ou',
    'Click to receive password reset instructions': 'Cliquez pour recevoir les instructions de réinitialisation du mot de passe',
    'This email is not valid or is not registered.': "Cet e-mail n'est pas valide ou n'est pas enregistré.",
    'Click to register': 'Cliquez pour vous inscrire',
    'We were unable to continue with this account.': 'Nous ne pouvons pas poursuivre avec ce compte.',
    'Please contact our support team at': "Veuillez contacter notre équipe d'assistance à l'adresse",
    'We could not verify this email right now. Please try again in a few moments.': "Nous n'avons pas pu vérifier cet e-mail pour le moment. Veuillez réessayer dans quelques instants.",
    'Incorrect email address or password. Please verify your details and try again.': 'Adresse e-mail ou mot de passe incorrect. Veuillez vérifier vos informations et réessayer.',
    'We could not send the link. Please try again.': "Nous n'avons pas pu envoyer le lien. Veuillez réessayer.",
    'Please wait a moment before requesting another link.': 'Veuillez patienter un instant avant de demander un nouveau lien.',
    'Link sent successfully': 'Lien envoyé avec succès',
    'Check your email.': 'Consultez votre boîte e-mail.',
    'We have sent you a new link to complete your registration.': 'Nous vous avons envoyé un nouveau lien pour finaliser votre inscription.',
    'Need help?': "Besoin d'aide ?",
    'Contact us': 'Contactez-nous',
    "Multiple payment attempts were detected with this card. Please verify that your details are correct before continuing. Check your banking app to confirm your available balance or see if you received a security alert.": "Plusieurs tentatives de paiement ont été détectées avec cette carte. Veuillez vérifier que vos informations sont exactes avant de continuer. Consultez l'application de votre banque pour confirmer votre solde disponible ou vérifier si vous avez reçu une alerte de sécurité.",
    "Select the payment currency": "Sélectionnez la devise de paiement",
    "Select the MXN currency on the top right corner if your card was issued in Mexico, or USD if it's an international card. This helps avoid payment rejections.": "Sélectionnez la devise MXN dans le coin supérieur droit si votre carte a été émise au Mexique, ou USD s'il s'agit d'une carte internationale. Cela permet d'éviter les rejets de paiement.",
    "Arrival": "Arrivée",
    "Airline": "Compagnie aérienne",
    "Flight no.": "N° de vol",
    "Arrival Date": "Date d'arrivée",
    "Arrival Time": "Heure d'arrivée",
    "Pickup Time": "Heure de prise en charge",
    "Departure": "Départ",
    "Departure Date": "Date de départ",
    "Departure Time": "Heure de départ",
    "Flight Arrival Date": "Date d'arrivée du vol",
    "Flight Arrival Time": "Heure d'arrivée du vol",
    "Flight Departure Date": "Date de départ du vol",
    "Flight Departure Time": "Heure de départ du vol",
    'An error has occurred, returning to home.': 'Une erreur est survenue, retour à l\'accueil.',
    'Please turn your device vertically for a better user experience. Thanks': 'Veuillez tourner votre appareil à la verticale pour une meilleure expérience utilisateur. Merci',
    'An error has occurred trying login': 'Une erreur est survenue lors de la connexion',
    'Dates': 'Dates',
    '{n} night': '{n} nuit',
    '{n} nights': '{n} nuits',
    'Destination': 'Destination',
    'Couldn\'t retrieve budget': '',
    'No Availability for this search': 'Aucune disponibilité pour cette recherche',
    'The hotel has no rooms available for the selected dates. If you wish, you can try other dates, search again for another hotel or destination, or contact our call center.': 'L\'hôtel n\'a pas de chambres disponibles pour les dates sélectionnées. Si vous le souhaitez, vous pouvez essayer d\'autres dates, chercher un autre hôtel ou destination, ou contacter notre centre d\'appels.',
    'The budget link contains errors': 'Le lien du budget contient des erreurs.',
    'Please review and fix the following errors from the link': 'Veuillez examiner et corriger les erreurs du lien',
    'Loading': 'Chargement',
    'Checking your budget': '',
    'Need more time?': 'Besoin de plus de temps ?',
    'We keep for you the same price for 24 hrs.': 'Nous garantissons le même prix pendant 24 heures.',
    'No questions asked!': 'Pas de questions posées !',
    'See Terms and Conditions': 'Voir les termes et conditions',
    'Lock this price': 'Verrouiller ce prix',
    '1 Adult': '1 Adulte',
    '{n} Adults': '{n} Adultes',
    '1 Child': '1 Enfant',
    '{n} Children': '{n} Enfants',
    '1 Infant': '1 Bébés',
    '{n} Infants': '{n} Bébés',
    'Saved on': 'Enregistré le',
    'Check  In': 'Enregistrement',
    'Rooms': 'Chambres',
    'Check Out': 'Départ',
    'Guests': 'Invités',
    'Rate': 'Tarif',
    'Fee': 'Frais',
    'Total Price': 'Prix total',
    'Room extras': 'Extras de chambre',
    'Airport - Hotel Transportation': 'Transport aéroport - hôtel',
    'Name': 'Nom',
    'E-mail': 'E-mail',
    'We will send you an E-mail to guarantee your spot for 24hrs': 'Nous vous enverrons un e-mail pour garantir votre place pendant 24 heures',
    'This information will not be used for promotional purposes': 'Ces informations ne seront pas utilisées à des fins promotionnelles',
    'Send': 'Envoyer',
    'Wait a moment, please...': 'Un moment, s\'il vous plaît...',
    'Loading booking...': 'Chargement de la réservation...',
    'Error': 'Erreur',
    'Sorry, we could not retrieve your booking. Please, contact the hotel.': 'Désolé, nous n\'avons pas pu récupérer votre réservation. Veuillez contacter l\'hôtel.',
    'Booking details': 'Détails de la réservation',
    'Hotel': 'Hôtel',
    'Status': 'État',
    'Email': 'Email',
    'Amount': 'Montant',
    'Cancellation fee': 'Frais d\'annulation',
    'An error happened while cancelling your booking.': 'Une erreur s\'est produite lors de l\'annulation de votre réservation.',
    'Please, write a reason...': 'Veuillez écrire un motif...',
    'Yes, cancel this booking': 'Oui, annuler cette réservation',
    'No, I don\'t want to cancel': 'Non, je ne veux pas annuler',
    'Booking was cancelled correctly.': 'La réservation a été annulée correctement.',
    'This booking can not be cancelled.': 'Cette réservation ne peut pas être annulée.',
    'Tell us your reason for cancelling': 'Dites-nous votre motif d\'annulation',
    'This is needed to complete your cancellation': 'Ceci est nécessaire pour compléter votre annulation',
    'Guaranteed online best price!': 'Meilleur prix garanti en ligne !',
    'Total price': 'Prix total',
    '* taxes included': '* taxes incluses',
    'Validating...': 'Validation...',
    'Please enter your {loyalty} Code.': 'Veuillez entrer votre code {loyalty}.',
    'Not a Valid Code': 'Code non valide',
    'Please enter your sandosSMARTagents.com referral code if you are already a member. If not, register now.': 'Veuillez entrer votre code de référence sandosSMARTagents.com si vous êtes déjà membre. Sinon, inscrivez-vous maintenant.',
    'Description': 'Description',
    'Same as user registration': 'Identique aux données d\'inscription',
    'Last name': 'Nom de famille',
    "Second last name": "Deuxième nom de famille",
    'Middle Name': 'Deuxième prénom',
    'Country / Region*': 'Pays / région*',
    'Telephone (mobile number preferred)': 'Téléphone (numéro mobile préféré)',
    'Telephone': 'Téléphone',
    'Address': 'Adresse',
    'City': 'Ville',
    'Zip code': 'Code postal',
    'E-mail address': 'Adresse e-mail',
    'Confirm e-mail address': 'Confirmer l\'adresse e-mail',
    'Client e-mail address': 'Adresse e-mail du client',
    'Confirm client e-mail address': 'Confirmer l’adresse e-mail du client',
    'Comments': 'Commentaires',
    'Estimated arrival time*': 'Heure d\'arrivée estimée*',
    'Card Type': 'Type de carte',
    'Card number': 'Numéro de carte',
    'Card holder': 'Titulaire',
    'CVC': 'CVC',
    'Expiry month*': 'Mois d\'expiration*',
    'Expiry year*': 'Année d\'expiration*',
    'Your sandosSMARTagents.com referral code:': 'Votre code de référence sandosSMARTagents.com :',
    'I accept the': 'J\'accepte les',
    'Terms & Conditions': 'Termes et conditions',
    'member': 'membre',
    'YES!': 'OUI!',
    'NO!': 'NON!',
    '{loyalty} Code here:': 'Code {loyalty} ici :',
    'I am a travel agent booking on behalf of my clients': 'Je suis un agent de voyages réservant pour le compte de mes clients',
    'I want to receive exclusive benefits and news by email': 'Je souhaite recevoir des offres et des nouvelles exclusives par e-mail',
    'Please select your {fieldName}': 'Veuillez sélectionner votre {fieldName}',
    'Back': 'Retour',
    'Book now': 'Réserver maintenant',
    'Save your price for 24hrs': 'RÉSERVEZ VOTRE PRIX PENDANT 24 HEURES !',
    'Budget Sent': 'Budget envoyé',
    'Budget Error': 'Erreur de budget',
    'Budget sent correctly. You will receive an email with a link to access it': 'Budget envoyé correctement. Vous recevrez un e-mail avec un lien pour y accéder',
    'Sorry, your budget could not be saved. Please try again or contact our Call Center for assistance': 'Désolé, votre budget n\'a pas pu être enregistré. Veuillez réessayer ou contacter notre centre d\'appels pour assistance.',
    'You have 24 hours to confirm your reservation without changes in both availability and the initial price.': 'Vous avez 24 heures pour confirmer votre réservation sans changement dans la disponibilité et le prix initial.',
    'During that time, we will send you an e-mail with all the data you have saved and a link so you can continue with your reservation.': 'Pendant ce temps, nous vous enverrons un e-mail avec toutes les données que vous avez enregistrées et un lien pour que vous puissiez continuer votre réservation.',
    'If after 24 hours you have not formalized your reservation, both the price and its availability could change.': 'Si après 24 heures vous n\'avez pas formalisé votre réservation, le prix et sa disponibilité pourraient changer.',
    'Please, select your payment method': 'Veuillez sélectionner votre méthode de paiement',
    'Enter your details, you\'re almost done!': 'Entrez vos détails, vous y êtes presque !',
    'Online payment will take place on the next page through a secure portal.': 'Le paiement en ligne se fera sur la page suivante via un portail sécurisé.',
    'This rate has no payment method available, please choose another rate.': 'Ce tarif n\'a pas de méthode de paiement disponible, veuillez en choisir un autre.',
    'Updating available payment methods, please wait...': 'Mise à jour des méthodes de paiement disponibles, veuillez patienter...',
    'When would you like to pay?': 'Quand aimeriez-vous payer ?',
    'Send an email with the Payment link to the customer': 'Envoyer un e-mail avec le lien de paiement au client',
    'Fill in these missing fields to continue:': 'Veuillez remplir ces champs manquants pour continuer :',
    'Please accept Terms and Conditions': 'Veuillez accepter les termes et conditions',
    'Please, make sure both emails are the same.': 'Veuillez vous assurer que les deux e-mails sont identiques.',
    'Please review your e-mail address': 'Veuillez vérifier votre adresse e-mail',
    'This card has expired': 'Cette carte a expiré',
    'Card Number Invalid': 'Numéro de carte invalide',
    'Card Type Invalid': 'Type de carte invalide',
    '{fieldName} is a required field': 'Le champ {fieldName} est requis',
    '{fieldName} should be at least {length} characters long': '{fieldName} doit contenir au moins {length} caractères',
    '{fieldName} must be {length} characters long at most': '{fieldName} doit contenir au plus {length} caractères',
    'Incorrect data, check the {fieldName}': 'Données incorrectes, vérifiez le {fieldName}',
    'Please, review this field. Incorrect format.': 'Veuillez vérifier ce champ. Format incorrect.',
    'Check this field. Don\'t use numbers or special characters.': 'Vérifiez ce champ. N\'utilisez pas de chiffres ou de caractères spéciaux.',
    'Please review your phone number': 'Veuillez vérifier votre numéro de téléphone',
    'Your booking is being confirmed': 'Votre réservation est en cours de confirmation',
    'Please wait while we confirm your booking': 'Veuillez patienter pendant que nous confirmons votre réservation',
    'Sorry, your booking could not be confirmed': 'Désolé, votre réservation n\'a pas pu être confirmée',
    'If the problem persists, please take a screenshot and contact the hotel.': 'Si le problème persiste, veuillez faire une capture d\'écran et contacter l\'hôtel.',
    'One moment, please. You are being redirected to the chosen payment page.': 'Un instant, s\'il vous plaît. Vous êtes redirigé vers la page de paiement choisie.',
    'Enter your member email or Loyalty Number here.': 'Entrez ici votre e-mail de membre ou votre numéro de fidélité.',
    '* Redeem coins to obtain discounts up to ': '* Échangez des pièces pour obtenir des réductions allant jusqu\'à ',
    'Hotel results could not be loaded': 'Les résultats de l\'hôtel n\'ont pas pu être chargés',
    'Hotel was returned without rooms': 'L\'hôtel a été retourné sans chambres',
    'Remove all rooms': 'Supprimer toutes les chambres',
    'Continue': 'Continuer',
    'CONTINUE': 'CONTINUER',
    'Please select your rooms': 'Veuillez sélectionner vos chambres',
    'child': 'enfant',
    'children': 'enfants',
    'years': 'ans',
    'adult': 'adulte',
    'adults': 'adultes',
    'Cart is updating...': 'Mise à jour du panier...',
    '(Coins redeemed)': '(Pièces échangées)',
    'There was an error updating your cart': 'Une erreur est survenue lors de la mise à jour de votre panier',
    'The occupancy of the room could not be updated': 'L\'occupation de la chambre n\'a pas pu être mise à jour',
    'No more than 5 rooms can be added to the basket': 'Un maximum de 5 chambres peut être ajouté au panier',
    'The room could not be added': 'La chambre n\'a pas pu être ajoutée',
    'Show Calendar': 'Afficher le calendrier',
    'Occupancy below min paxes': 'Occupation inférieure au minimum',
    'Update': 'Mettre à jour',
    'infants': 'bébés',
    'hide details': 'masquer les détails',
    'show details': 'afficher les détails',
    '{items} in basket': '{items} dans le panier',
    'Please correct the price to select the room': 'Veuillez corriger le prix pour sélectionner la chambre',
    'Adding...': 'Ajout en cours...',
    'Added': 'Ajouté',
    'Added ✔': 'Ajouté ✔',
    'Select': 'Sélectionner',
    'Not available: Minimum stay - {nights} nights': 'Non disponible : séjour minimum - {nights} nuits',
    'Not available: {reason}': 'Non disponible : {reason}',
    'Rate code: {code}': 'Code tarifaire : {code}',
    'There was an error updating the room occupancy': 'Une erreur s\'est produite lors de la mise à jour de l\'occupation de la chambre',
    'person': 'personne',
    'persons': 'personnes',
    'Max.': 'Max.',
    'see details': 'voir les détails',
    'From': 'À partir de',
    'No availability with the details you selected': 'Aucune disponibilité avec les détails que vous avez sélectionnés',
    'Sorry, but there is no availability for the hotel and dates you selected.': 'Désolé, mais il n\'y a pas de disponibilité pour l\'hôtel et les dates que vous avez sélectionnées.',
    'Minimum stay {n} nights': 'Séjour minimum {n} nuits',
    'Distance': 'Distance',
    'Please check our other hotels - the hotel you requested has no availability': 'Veuillez vérifier nos autres hôtels - l\'hôtel que vous avez demandé n\'a pas de disponibilité',
    'Sorry, no availability was found in nearby hotels': 'Désolé, aucune disponibilité n\'a été trouvée dans les hôtels à proximité',
    'We are checking availability in nearby hotels': 'Nous vérifions la disponibilité dans les hôtels à proximité',
    'Sorry, the hotel you requested has no availability': 'Désolé, l\'hôtel que vous avez demandé n\'a pas de disponibilité',
    'Availability in hotels': 'Disponibilité dans les hôtels',
    'Availability in other hotels': 'Disponibilité dans d\'autres hôtels',
    'Minimum of nights': 'Minimum de nuits',
    'Not available': 'Non disponible',
    'Selected': 'Sélectionné',
    'Omit restrictions and proceed to rooms': 'Omettre les restrictions et passer aux chambres',
    'Hotel Calendar': 'Calendrier de l\'hôtel',
    'Your last search returned no results. Adjust the stay dates using the calendar below': 'Votre dernière recherche n\'a donné aucun résultat. Ajustez les dates de séjour en utilisant le calendrier ci-dessous',
    'Latest search was for': 'La dernière recherche était pour',
    'nights from': 'nuits à partir de',
    'to': 'à',
    'Check availability': 'Vérifier la disponibilité',
    'Add': 'Ajouter',
    'Guest {n}': 'Invité {n}',
    'Age {age}': 'Âge {age}',
    'Second last name': 'Deuxième nom',
    'Room {n}': 'Chambre {n}',
    'Your message was sent correctly': 'Votre message a été envoyé correctement',
    'Your message could not be sent to the hotel': 'Votre message n\'a pas pu être envoyé à l\'hôtel',
    'Submit': 'Soumettre',
    'Write your message to the hotel': 'Écrivez votre message à l\'hôtel',
    'contact the hotel': 'contacter l\'hôtel',
    'view policies': 'voir les politiques',
    'You can also find bookable transfers in the email we just sent you': 'Vous pouvez également trouver les transferts réservables dans l\'e-mail que nous venons de vous envoyer',
    'Retrieving your booking...': 'Récupération de votre réservation...',
    'Booking Summary': 'Résumé de la réservation',
    'We are sorry, but your booking could not be retrieved. Please, contact the hotel for assistance.': 'Nous sommes désolés, mais votre réservation n\'a pas pu être récupérée. Veuillez contacter l\'hôtel pour assistance.',
    'Try again': 'Réessayez',
    'We are sorry, your booking has pending payments': 'Nous sommes désolés, votre réservation a des paiements en attente',
    'This means that the payment for your booking did not complete correctly.': 'Cela signifie que le paiement de votre réservation n\'a pas été effectué correctement. Veuillez contacter notre service clientèle.',
    'Please, contact our Call Center for assistance.': 'Veuillez contacter notre centre d\'appels pour assistance.',
    'Go to payment page': 'Accéder à la page de paiement',
    'Cancel your booking': 'Annuler votre réservation',
    'Affiliate number': 'Numéro d\'affilié',
    '{loyalty} customer code': 'Code client {loyalty}',
    'Access only valid for reservations done at Sandos.com and Call Center': 'Accès uniquement valable pour les réservations effectuées sur Sandos.com et Call Center',
    'Booking reference': 'Référence de réservation',
    'We could not find this booking': 'Nous n\'avons pas pu trouver cette réservation',
    'One moment, please...': 'Un moment, s\'il vous plaît...',
    'Customer link': 'Lien pour le client',
    'Send a link for an upfront payment for this booking': 'Envoyer un lien pour un paiement anticipé pour cette réservation',
    'Forward Voucher': 'Transmettre le bon',
    'Sending voucher...': 'Envoi du bon...',
    'Voucher sent successfully': 'Bon envoyé avec succès',
    'This booking has no outstanding payments': 'Cette réservation n\'a pas de paiements en attente',
    'Reservation details': 'Détails de la réservation',
    'Reservation Details': 'Détails de la réservation',
    'Just one moment, please...': 'Un instant, s\'il vous plaît...',
    'Proceed to the payment system': 'Accéder au système de paiement',
    'Select your payment method': 'Sélectionnez votre méthode de paiement',
    'Sorry, the payment upfront cannot be done now. Please try later': 'Désolé, le paiement anticipé ne peut pas être effectué maintenant. Veuillez réessayer plus tard',
    'This booking cannot be paid upfront': 'Cette réservation ne peut pas être payée à l\'avance',
    'General Conditions': 'Conditions générales',
    'Loading hotel policies...': 'Chargement des politiques de l\'hôtel...',
    'discount': 'réduction ',
    'applied': 'appliqué',
    'Adults only': 'Adultes seulement',
    'Selected currency amounts': 'Montants en devise sélectionnée',
    'Room {num} selection': '',
    'Board': 'Régime',
    'Different rates or boards have been selected': '',
    'Would you like to keep the original rate and board, or change to those of Room 2?': '',
    'You can also change your selection later': '',
    'Keep original selection': '',
    'Use room 2 selection': '',
    'Please review your selection': 'Veuillez vérifier votre sélection',
    'change {roomType}': 'Dernière {roomType} disponible !',
    'select {roomType} {n}': '',
    'per night': 'par nuit',
    'total price': 'prix total',
    'Clear selection': '',
    'Adding rooms...': 'Ajout de chambres...',
    'Choose this solution': 'Choisir cette solution',
    'OR': '',
    'Customize your solution': 'Personnalisez votre solution',
    'Your customized solution': 'Votre solution personnalisée',
    'Add an Extra Night and Receive a {discount}% Extra Long Stay Discount! Book now!': 'Ajoutez une nuit supplémentaire et recevez une réduction de {discount}% sur le séjour prolongé ! Réservez maintenant !',
    'Ok! Let\'s change it': 'D\'accord ! Changeons-le',
    'What is included': 'Ce qui est inclus',
    'Extra cost': 'Coût supplémentaire',
    'Key selling points': 'Points forts',
    'View gallery': 'Voir la galerie',
    'Applied Promocode': 'Code promotionnel appliqué',
    '{quota} {roomTypes} left': 'Il reste seulement {quota} {roomType}',
    'No availability': 'Pas de disponibilité',
    'Last available {roomType}!': 'Dernière {roomType} disponible !',
    'Only {quota} {roomTypes} left': 'Il ne reste que {quota} {roomTypes}',
    '<span>From </span><b class=\'price-value\'>{amount}</b><span> per night</span>': '<span>À partir de </span><b class="price-value">{amount}</b><span> par nuit</span>',
    'Adults Only': 'Adultes seulement',
    'Suite Inclusions': 'Ce qui est inclus',
    'All rooms': 'Toutes les chambres',
    'Recommended': 'Recommandé',
    'Price: Low to High': 'Prix: bas à haut',
    'Price: High to Low': 'Prix: haut à bas',
    'View results by': 'Afficher les résultats par',
    'Sort by': 'Trier par',
    'View rates in': 'Voir les tarifs en',
    'Invalid Promo Code: Enter a different code, make sure is written with CAPITAL LETTERS or continue with your booking.': 'Code promo invalide : entrez un code différent, assurez-vous qu\'il soit écrit en LETTRES MAJUSCULES ou continuez avec votre réservation.',
    'Select Room Type for Room ': '',
    'Other Rooms Available': '',
    'Invalid Promo Code: Enter a different code or continue with your booking.': 'Code promotionnel invalide : entrez un code différent ou continuez avec votre réservation.',
    'Free cancellation': 'Annulation gratuite',
    'Cancellation conditions': 'Conditions d\'annulation',
    'Off': 'De Réduction',
    'Long Stay': 'Long Séjour',
    'Best Rate': 'Meilleur tarif',
    'Adding rooms ...': 'Ajout de chambres...',
    'Select best rate': 'Meilleur tarif',
    'total': 'au total',
    'Best rate': 'Meilleur tarif',
    'Room 360º': 'Chambre 360º',
    'Room Floor Plan': '',
    'Room video': 'Vidéo de la chambre',
    'Congratulations! Good choice!': 'Félicitations ! Bon choix !',
    'You are about to book a room': 'Vous êtes sur le point de réserver une chambre',
    'Which includes among other amenities and services:': 'Qui inclut parmi d\'autres équipements et services :',
    '{n} people are checking this hotel': '{n} personnes consultent cet hôtel',
    'Book': 'Réserver',
    'We use cookies to personalize content and ads, improve your user experience, and to analyze our traffic.': 'Nous utilisons des cookies pour personnaliser le contenu et les annonces, améliorer votre expérience utilisateur et analyser notre trafic.',
    'We also share information about your use of our website with our social media, advertising, and analytics partners.': 'Nous partageons également des informations sur votre utilisation de notre site web avec nos partenaires de réseaux sociaux, de publicité et d\'analyse.',
    'Continue if you agree, or read more about our use of cookies here.': 'Continuez si vous êtes d\'accord, ou lisez plus sur notre utilisation des cookies ici.',
    'Apply': 'Enregistrer les préférences',
    'Configure': 'Configurer',
    'More info': 'Plus d\'info',
    'Ok, I agree': 'Ok, j\'accepte',
    'Analysis cookies': 'Cookies d\'analyse',
    'Advertising cookies': 'Cookies publicitaires',
    'Personalization cookies': 'Cookies de personnalisation',
    'Compulsory cookies': 'Cookies obligatoires',
    'These cookies allow us to analyze and measure how you use the website to improve browsing.': 'Ces cookies nous permettent d\'analyser et de mesurer comment vous utilisez le site pour améliorer la navigation.',
    'Advertising companies use these cookies to publish adverts that match your interests.': 'Les entreprises publicitaires utilisent ces cookies pour publier des annonces qui correspondent à vos intérêts.',
    'These cookies allow us to analyze your user profile and use of the website to give you a personalized experience.': 'Ces cookies nous permettent d\'analyser votre profil d\'utilisateur et votre utilisation du site pour vous offrir une expérience personnalisée.',
    'These cookies are essential for the website to work correctly.': 'Ces cookies sont essentiels pour que le site fonctionne correctement.',
    'Ages': 'Âges',
    'Children': 'Enfants',
    'Ages under': 'Âge inférieur à',
    'Infants': 'Bébés',
    'Adults': 'Adultes',
    'Edit': 'Éditer',
    'Save': 'Enregistrer',
    'Enhance your Stay': 'Améliorez votre séjour',
    'Tours and Activities': 'Visites et Activités',
    'Passengers': 'Passagers',
    'This booking is already cancelled': 'Cette réservation est déjà annulée',
    'When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).': 'Lors de votre départ de l\'hôtel, des {chain} coins seront ajoutées au compte du membre {chain} qui a effectué la réservation. Le montant sera basé sur le pourcentage correspondant à leur niveau d\'adhésion, calculé sur le montant du séjour (hors taxe).',
    'Hello {customer}, your reservation is {bookStatus}': 'Bonjour {customer}, votre réservation est {bookStatus}',
    'Thank you for choosing {hotel}': 'Merci d\'avoir choisi {hotel}',
    'A confirmation e-mail has been sent to this e-mail address:': 'Un e-mail de confirmation a été envoyé à cette adresse :',
    'Click here to register now': 'Cliquez ici pour vous inscrire maintenant',
    'and get 20 extra coins to use during your stay': 'et recevez 20 coins supplémentaires à utiliser pendant votre séjour',
    'Incorrect data, check the {label}': 'Données incorrectes, vérifiez le {label}',
    'Coins redeemed': 'Coins échangées',
    'PLAN YOUR TRIP': 'PLANIFIEZ VOTRE VOYAGE',
    '1 night': '1 nuit',
    'Hotel details': 'Détails de l\'hôtel',
    'Check-in': 'Arrivée',
    'Check-out': 'Départ',
    'Write a message to the hotel': 'Écrivez votre message à l\'hôtel',
    'I would like to know...': 'Je voudrais savoir...',
    'Loyalty': 'Fidélité',
    'Age': 'Âge',
    'This booking can not be cancelled': 'Cette réservation ne peut pas être annulée',
    'Cancellation costs': 'Frais d\'annulation',
    'Cancel your reservation': 'Annulez votre réservation',
    'Purchase': 'Achat',
    'Today': 'Aujourd\'hui',
    'Free cancelation': 'Annulation gratuite',
    'Confirm and close': 'Confirmer et fermer',
    'We are currently performing maintenance tasks. Please, try again in a few minutes...': 'Nous effectuons actuellement des tâches de maintenance. Veuillez réessayer dans quelques minutes...',
    '{chain} Hotels & Resorts. All rights reserved': '{chain} Hôtels & Resorts. Tous droits réservés',
    'Currency': 'Devise',
    'Language': 'Langue',
    'Close session': 'Déconnexion',
    'Hello {name}': 'Bonjour {name}',
    'Menu': 'Menu',
    'Book your next vacation!': 'Réservez vos prochaines vacances!',
    'As a {chain} member you can get discounts and benefits in exchange of coins': 'En tant que membre de {chain}, vous pouvez obtenir des réductions et des avantages en échange de coins',
    'Visit ': 'Visitez ',
    ' to see all benefits': ' pour voir tous les avantages',
    'Become a member': 'DEVENEZ MEMBRE',
    'Login': 'Connectez-vous',
    'Become a member now and get extra coins to use during your stay': 'devenez membre maintenant et obtenez des coins supplémentaires à utiliser pendant votre séjour',
    'Are you {chain} member?': 'Êtes-vous membre de {chain}?',
    'Register now and use a {coins} coins gift to apply to your booking': 'Inscrivez-vous maintenant et utilisez un cadeau de {coins} coins pour l\'appliquer à votre réservation',
    'As a {chain} member you can get discounts in exchange of coins and much more...': 'En tant que membre de {chain}, vous pouvez obtenir des réductions en échange de coins et bien plus encore...',
    'Congratulations!': 'Félicitations !',
    'As a member of Sandos4u this is the maximum price you can have with the accumulation of coins for having previously entrusted your rest days with us that you can confirm in the next step. You can decide if you want to apply them in this or the next one or save them to be able to buy Sandos4u rewards.': 'En tant que membre de Sandos4u, voici le prix maximum que vous pouvez avoir avec l\'accumulation de coins, que vous pourrez confirmer à l\'étape suivante. Vous pouvez décider si vous souhaitez les appliquer maintenant ou plus tard, ou les conserver pour acheter des récompenses Sandos4u.',
    '20 registration coins have been applied to you and this is the result of the new member fee. In the next booking step, you can decide if you want to apply them in this or next, or save them to buy prizes from Sandos4u.': '20 coins d\'inscription vous ont été appliqués et voici le résultat des frais de nouveau membre. À l\'étape de réservation suivante, vous pouvez décider si vous souhaitez les appliquer maintenant ou plus tard, ou les conserver pour acheter des prix de Sandos4u.',
    'or': 'ou',
    '*new members only': '* seulement pour les nouveaux membres',
    'LOGIN AT {chain}': 'CONNEXION À {chain}',
    'Password': 'Mot de passe',
    'Remember me': 'Souviens-toi de moi',
    'Forgotten your password?': 'Vous avez oublié votre mot de passe?',
    'Your available Coins': 'Vos Coins disponibles',
    'Hello': 'Bonjour',
    'Edit coins to use': 'Modifier les coins à utiliser',
    '{loyalty} coins': '{loyalty} coins',
    'will be awarded to you with this booking': 'seront attribués avec cette réservation',
    'Click here to register now ': 'Cliquez ici pour vous inscrire maintenant ',
    'and receive {coins} extra coins to use during your stay.': 'et recevoir {coins} coins supplémentaires à utiliser pendant votre séjour.',
    'Your Level': 'Votre niveau',
    '* Taxes included': '* Taxes incluses',
    'Taxes included': 'Taxes incluses',
    'coins': 'coins',
    'You could use up to {maxAvailDiscountCoins} coins from a total {maxCoins} from your {name} account to get an extra {maxAvailDiscountPercent}%': 'Vous pourriez utiliser jusqu\'à {maxAvailDiscountCoins} coins sur un total de {maxCoins} de votre compte {name} pour obtenir un {maxAvailDiscountPercent}% supplémentaire',
    '* TOTAL PRICE Taxes included': '* PRIX TOTAL Taxes incluses',
    'LOGIN': 'CONNEXION',
    'REGISTER': 'S\'INSCRIRE',
    'Register at {name} and receive {coins} Coins to Start Saving': 'Inscrivez-vous à {name} et recevez {coins} Coins pour commencer à économiser',
    'MY {brand} RATE': 'MON TARIF {brand}',
    'Join at {brand} and Start Saving Now': 'Rejoignez {brand} et commencez à économiser maintenant',
    'An error has occurred': 'Une erreur s\'est produite, retour à la page d\'accueil',
    'Forgotten password?': 'Mot de passe oublié ?',
    'If you have forgotten your password, we will send you a recover email': 'Si vous avez oublié votre mot de passe, nous vous enverrons un email de récupération',
    'Cancel': 'Annuler',
    'An email has been sent to you to recover your password.': 'Un email vous a été envoyé pour récupérer votre mot de passe.',
    'Paid amount (with payment method)': 'Montant payé (avec méthode de paiement)',
    'Paid amount with Loyalty coins': 'Montant payé avec les coins de fidélité',
    'Paid amount of Loyalty Coins used': 'Montant utilisé de coins de fidélité',
    'Pending amount to pay in hotel': 'Montant restant à payer à l\'hôtel',
    'Payment method': 'Méthode de paiement',
    'Loyalty coins used': 'Coins de fidélité utilisés',
    'my area': 'mon espace',
    'catalogue': 'catalogue',
    'how it works': 'Comment ça marche',
    'payment concepts': 'concepts de paiement',
    'Your wallet': 'Votre portefeuille',
    'Both emails does not mismatch': 'Les emails ne correspondent pas',
    'Both passwords does not mismatch': 'Les mots de passe ne correspondent pas',
    'I want to be a member of Sandos4U': 'Je veux être membre de Sandos4U',
    'I have read and accept the': 'J\'ai lu et j\'accepte les',
    'and the': 'et la',
    'Privacy Policy': 'Politique de Confidentialité',
    'A user with the provided email already exists': 'Un utilisateur avec l\'email fourni existe déjà',
    'Invalid email address. Please check and try again.': 'Adresse courriel invalide. Veuillez vérifier et réessayer.',
    'Last name': 'Nom de famille',
    'Middle name': 'Deuxième prénom',
    'Repeat email': 'Répétez l\'email',
    'Confirm password': 'Confirmer le mot de passe',
    '{dateIn} to {dateOut}': '{dateIn} à {dateOut}',
    'Sorry, but there are errors in your search. Please, check the parameters and try again.': 'Désolé, mais il y a des erreurs dans votre recherche. Veuillez vérifier les paramètres et réessayer.',
    'Checking availability for your booking:': 'Vérification de la disponibilité de votre réservation:',
    'Minimum stay {minStay} nights': 'Séjour minimum : {minStay} nuits',
    'For your better experience, the minimum stay of this hotel is {minStay} days': 'Pour une meilleure expérience, le séjour minimum dans cet hôtel est de {minStay} jours',
    'We have adjusted it for you. Do you want to have a look?': 'Nous l\'avons ajusté pour vous. Voulez-vous le vérifier?',
    'I\'ll do it myself': 'Je vais le faire moi-même',
    'OK, show me': 'D\'accord, montrez-moi',
    'Loading details from the Share link...': 'Chargement des détails du lien partagé...',
    'Sorry, we could not load the details from the Share link': 'Désolé, nous n\'avons pas pu charger les détails du lien partagé',
    'Copied!': 'Copié!',
    'Copy link': 'Copier le lien',
    'downloading PDF ...': 'téléchargement du PDF ...',
    'download as PDF': 'télécharger en tant que PDF',
    'Download Client Voucher PDF': 'Télécharger le bon client PDF',
    'Download Agency Voucher PDF': 'Télécharger le bon d’agence PDF',
    'You have chosen a net rate. This means that your commission is already automatically included in the public rate, so you will not have to take any additional steps to receive it.': 'Vous avez choisi un tarif net. Cela signifie que votre commission est déjà automatiquement incluse dans le tarif public, vous n’aurez donc aucune démarche supplémentaire à effectuer pour la recevoir.',
    'You have chosen a public rate. In this case, you will need to arrange your commission directly with the Sandos team in order to receive payment.': 'Vous avez choisi un tarif public. Dans ce cas, vous devrez organiser votre commission directement avec l’équipe Sandos afin de recevoir le paiement.',
    'Email is repeated': 'Email répété',
    'Invalid email': 'Email invalide',
    'Please add at least one e-mail address': 'Veuillez ajouter au moins une adresse e-mail',
    'Add email': 'Ajouter un email',
    'Sending...': 'Envoi en cours...',
    'Send by mail': 'Envoyer par email',
    'Enter one or more email addresses': 'Entrez une ou plusieurs adresses email',
    'Share with more friends': 'Partager avec plus d\'amis',
    'DONE': 'FAIT',
    'The information you wanted to share has been emailed to :': 'Les informations que vous vouliez partager ont été envoyées par email à :',
    'Email Sent': 'Email envoyé',
    'share with others': 'partager avec les autres',
    'Username': 'Nom d\'utilisateur',
    'Have you forgotten your password?': 'Avez-vous oublié votre mot de passe?',
    'Please check your email inbox with the link to reset your password': 'Veuillez vérifier votre boîte de réception pour le lien de réinitialisation de votre mot de passe',
    'Sorry, your username could not be verified': 'Désolé, votre nom d\'utilisateur n\'a pas pu être vérifié',
    'You are already logged in': 'Vous êtes déjà connecté',
    'Back to login': 'Retour à la connexion',
    'Enter your username or email': 'Entrez votre nom d\'utilisateur ou votre email',
    'If a user matches, an email will be sent that will allow you to reset your password': 'Si un utilisateur correspond, un email sera envoyé pour vous permettre de réinitialiser votre mot de passe',
    'Email / Username': 'Email / Nom d\'utilisateur',
    'Reset password': 'Réinitialiser le mot de passe',
    'Your password has been updated': 'Votre mot de passe a été mis à jour',
    'Your password could not be reset, please try again': 'Votre mot de passe n\'a pas pu être réinitialisé, veuillez réessayer',
    'Choose your new password': 'Choisissez votre nouveau mot de passe',
    'Repeat your new password': 'Répétez votre nouveau mot de passe',
    'Call Center': 'Centre d\'appel',
    'infant': 'bébé',
    'Opening Hours': 'Heures d\'ouverture',
    'For bookings or more information dial ': 'Pour les réservations ou plus d\'informations, composez le ',
    'or contact: ': 'ou contactez: ',
    'Extras': 'Extras',
    'Transportation': 'Transports',
    'Tours and activities': 'Visites et activités',
    'Transportation cost': 'Coût du transport',
    'One way': 'Aller simple',
    'Round trip': 'Aller-retour',
    'Call Center Customer Code': 'Code client du centre d\'appel',
    'Please enter a valid email.': 'Veuillez entrer une adresse email valide.',
    'You have a {new_member_discount_percentage}% discount from the total cost of the booking': 'Vous avez un rabais de {new_member_discount_percentage}% sur le coût total de la réservation',
    '% Discount': '% de rabais',
    'Total Price:': 'Prix total:',
    'Register at {name} to get a {new_member_discount_percentage}% on your 1st booking': 'Inscrivez-vous à {name} pour obtenir un {new_member_discount_percentage}% sur votre 1ère réservation',
    'REGISTER NOW ': 'INSCRIVEZ-VOUS MAINTENANT',
    'TO GET A': 'POUR OBTENIR UN',
    '{percentage}% DISCOUNT ': '{percentage}% DE RÉDUCTION ',
    'ON YOUR 1ST BOOKING': 'SUR VOTRE 1ÈRE RÉSERVATION',
    'REGISTER NOW to get a {percentage}% discount on your 1st booking': 'INSCRIVEZ-VOUS MAINTENANT pour obtenir une réduction de {percentage}% sur votre 1ère réservation',
    'Stay': 'Séjour',
    'Board type': 'Type de pension',
    'Board Type': 'Type de Pension',
    'Rooms and Extras': 'Chambres et Extras',
    'Final Price': 'Prix Final',
    'Blue': 'Bleu',
    'Gold': 'Or',
    'Nights': 'Nuits',
    'Bookings': 'Réservations',
    'in the last 2 years': 'au cours des 2 dernières années',
    'in the last year': 'au cours de la dernière année',
    'Room 0': 'Chambre 0',
    'Type': 'Type',
    '*Once the reservation is booked, please check your confirmation email to finish setting up your transportation.': '*Une fois la réservation effectuée, veuillez vérifier votre email de confirmation pour terminer la configuration de votre transport.',
    'You have not selected all the rooms yet...': 'Vous n\'avez pas encore sélectionné toutes les chambres...',
    'People': 'Personnes',
    'Use Coins': 'Utiliser des Coins',
    'Change Search': 'Modifier la Recherche',
    'Register and': 'Inscrivez-vous et',
    'Earn 20 Coins': 'Gagnez 20 Coins',
    'to book your next stay': 'pour réserver votre prochain séjour',
    '*(1 Coin = 1 Dollar/Euro)': '*(1 Coin = 1 Dollar/Euro)',
    'Register Now!': 'Inscrivez-vous maintenant!',
    'Learn More about': 'En savoir plus sur',
    'Applied to this room': 'Appliqué à cette chambre',
    'Note: The final amount of your reservation will be charged in': 'Remarque : Le montant final de votre réservation sera facturé en',
    'equivalent to': 'équivalent à',
    'Register at {name}': 'Inscrivez-vous à {name}',
    'to get a': 'pour obtenir un',
    '% discount': '% de réduction',
    'on your 1st booking': 'sur votre 1ère réservation',
    'Select Room': 'Sélectionner la Chambre',
    'Our best rate options for your reservation': 'Nos meilleures options de tarif pour votre réservation',
    'Select your rate': 'Sélectionnez votre tarif',
    'Empty Cart': 'Vider le Panier',
    'Register to get the best member rate on this booking and win coins to use on your next reservation': 'Inscrivez-vous pour obtenir le meilleur tarif membre sur cette réservation et gagnez des coins à utiliser sur votre prochaine réservation.',
    'JOIN SANDOS4U': 'REJOIGNEZ SANDOS4U',
    'BEST RATE GUARANTEED': 'MEILLEUR TARIF GARANTI',
    'Just by being a member you get access to a preferential rate.': 'En tant que membre, vous accédez à un tarif préférentiel.',
    'WIN COINS FOR EACH RESERVATION': 'GAGNEZ DES COINS POUR CHAQUE RÉSERVATION',
    'When you check out you will get Coins that will be added to your account.': 'Lors de votre départ, vous obtiendrez des Coins qui seront ajoutés à votre compte.',
    'REDEEM YOUR COINS FOR PRIZES AND STAYS': 'ÉCHANGEZ VOS COINS CONTRE DES PRIX ET DES SÉJOURS',
    'Exchange your coins for incredible prizes.': 'Échangez vos coins contre des prix incroyables.',
    'Login with your email': 'Connectez-vous avec votre email',
    'Enter': 'Entrer',
    'Recover password': 'Récupérer le mot de passe',
    'Not a member of Sandos4U yet?': 'Pas encore membre de Sandos4U ?',
    'Register': 'Créez votre compte',
    'REGISTER NOW TO GET THE BEST RATE GUARANTEED': 'INSCRIVEZ-VOUS MAINTENANT POUR OBTENIR LE MEILLEUR TARIF GARANTI',
    'Discount applied': 'Réduction appliquée',
    '{brand} {loyaltyLevel} Discount': '{brand} {loyaltyLevel} Réduction',
    'Coins Redeemed': 'Coins échangés',
    'Have an account?': 'Vous avez un compte?',
    'Sign in now': 'Connectez-vous maintenant',
    '{brand} {loyaltyLevel} RATE': 'TARIF {brand} {loyaltyLevel}',
    '{brand} RATE': 'TARIF {brand}',
    'The payment has not been completed. Please verify your information and try again.': 'Le paiement n\'a pas été complété. Veuillez vérifier vos informations et réessayer.',
    'Your Coins': 'Vos Coins',
    'FINAL PRICE': 'PRIX FINAL',
    'Arrival Flight no.': 'Numéro de vol d\'arrivée',
    'Departure Flight no.': 'Numéro de vol de départ',
    'Apply All': 'Tout Appliquer',
    'Available Coins': 'Coins Disponibles',
    'Discount': 'Réduction ',
    'Sign up now at': 'Inscris-toi maintenant sur',
    'Continue without an account': 'Continuer sans compte',
    'Plus': 'Plus',
    'Create Account': 'Créer un compte',
    '**1 S4U Coin = $1 {currency_to_use_coins}': '**1 S4U Coin = $1 {currency_to_use_coins}',
    'At the moment of Check-Out': 'Au moment du Check-Out',
    '{loyaltyName} Discount': 'Réduction {loyaltyName}',
    '*Approximate amount of Coins': '*Quantité approximative de Coins',
    'Register or log-in Now at {loyalty_name}': 'Inscrivez-vous ou connectez-vous maintenant sur {loyalty_name}',
    'Log-In': 'Se connecter',
    'Hi': 'Bonjour',
    'YOUR RESERVATION': 'VOTRE RÉSERVATION',
    'IS': 'EST',
    'HAS BEEN': 'A ÉTÉ',
    'CANCELLED': 'ANNULÉE',
    'REVOQUED': 'RÉVOQUÉE',
    'PENDING': 'EN ATTENTE',
    'CONFIRMED': 'CONFIRMÉE',
    'On behalf of the Sandos family, we would like to warmly welcome you to {hotel_name}.': 'Au nom de la famille Sandos, nous vous souhaitons la bienvenue à {hotel_name}.',
    'We are looking forward to your upcoming visit. Below you will find your reservation details:': 'Nous sommes impatients de vous accueillir. Vous trouverez ci-dessous les détails de votre réservation:',
    "BOOKING DETAILS": "DÉTAILS DE LA RÉSERVATION",
    "Confirmation Number:": "Numéro de confirmation:",
    "Reservation Status:": "Statut de la réservation:",
    "Total Price:": "Prix total:",
    "Amount Paid (with payment method):": "Montant payé (avec méthode de paiement):",
    "Pending Amount to Pay at the Hotel:": "Montant restant à payer à l'hôtel:",
    "Loyalty Coins Used:": "Pièces de fidélité utilisées:",
    "Coins": "Coins",
    "At check-out, SANDOS4U coins will be added to the account of the SANDOS4U Member who made the reservation. The amount will be calculated based on the percentage corresponding to their membership level, applied to the total stay (excluding taxes).": "Lors du check-out, des points SANDOS4U seront ajoutés au compte du membre SANDOS4U qui a effectué la réservation. Le montant sera calculé en fonction du pourcentage correspondant à son niveau d'adhésion, appliqué au séjour total (hors taxes).",
    "GUEST INFORMATION": "INFORMATIONS SUR LE CLIENT",
    "Edit": "Modifier",
    "Guest Name:": "Nom du client:",
    "Email:": "E-mail:",
    "Country:": "Pays:",
    "Country": "Pays",
    "Check-in / Check-out": "Enregistrement / Départ",
    "Check-in Time:": "Heure d'arrivée:",
    "Check-out Time:": "Heure de départ:",
    "ROOM DETAILS": "DÉTAILS DE LA CHAMBRE",
    "Total:": "Total:",
    "Room": "Chambre",
    "Room Type:": "Type de chambre:",
    "Rate:": "Tarif:",
    "Occupants:": "Occupants:",
    "Adults": "Adultes",
    "children": "enfants",
    "Plan:": "Plan:",
    "Arrival Date:": "Date d'arrivée:",
    "Departure Date:": "Date de départ:",
    "Room amount:": "Montant de la chambre:",
    "Room amount (client):": "Montant de la chambre (client):",
    "Room amount (agent):": "Montant de la chambre (agent):",
    "UPGRADES/EXTRAS DETAILS": "DÉTAILS DES OPTIONS/SUPPLÉMENTS",
    "(Please inquire at the front desk for more information about available upgrades and extras).": "(Veuillez vous renseigner à la réception pour plus d'informations sur les options et suppléments disponibles).",
    "If you have any questions or special requests, please do not hesitate to contact us.": "Si vous avez des questions ou des demandes particulières, n'hésitez pas à nous contacter.",
    "We hope you enjoy your stay at {hotel_name}!": "Nous espérons que vous apprécierez votre séjour au {hotel_name}!",
    "Our best rate options for your reservation": "Nos meilleurs tarifs pour votre réservation",
    "Is everything correct?": "Tout est correct ?",
    "You can check or modify your booking online without needing to register.": "Vous pouvez vérifier ou modifier votre réservation en ligne sans avoir besoin de vous inscrire.",
    "Cancel your booking": "Annuler votre réservation",
    "Change the dates": "Modifier les dates",
    "Change your room": "Changer votre chambre",
    "Request invoice": "Demander une facture",
    "Contact Us": "Contactez-nous",
    "Call center:": "Centre d'appels:",
    "Contact the hotel": "Contacter l'hôtel",
    "Remember, you can make changes to this booking anytime.": "N'oubliez pas que vous pouvez modifier cette réservation à tout moment.",
    'Select the room you want to edit': 'Sélectionnez la chambre que vous souhaitez modifier',
    'Pay now to confirm your booking': 'Payez maintenant pour confirmer votre réservation',
    'Confirm change': 'Confirmer le changement',
    'Confirm the changes to apply the update': 'Confirmez les modifications pour appliquer la mise à jour',
    'You are editing your reservation': 'Vous modifiez votre réservation',
    'Exit edit mode': 'Quitter le mode édition',
    "We're sorry": "Nous sommes désolés",
    'This room is currently unavailable': "Cette chambre n'est pas disponible pour le moment",
    "Mexico and Others:": "Mexique et autres:",
    "Spain and Europe:": "Espagne et Europe:",
    "USA:": "États-Unis:",
    "Canada:": "Canada:",
    "Argentina:": "Argentine:",
    "Brazil:": "Brésil:",
    "UK:": "Royaume-Uni:",
    "Rate without taxes": "Tarif hors taxes",
    "Taxes": "Impôts",
    "Price details": "Détails des prix",
    "Net price": "Net",
    "Public price": "Public",
    "Price": "Prix",
    "Offer applied": "Offre appliquée",
    "(Price per room per night)": "(Prix par chambre et par nuit)",
    "Total": "Total",
    "I agree to receive promotions from Sandos4U": "J'accepte de recevoir des promotions de Sandos4U",
    "Up to {months} months interest-free (with eligible credit cards)": "Jusqu'à {months} ​​mois sans intérêt (avec les cartes de crédit éligibles)",
    "INTEREST FREE INSTALLMENTS": "MOIS SANS INTÉRÊTS",
    "(FOR DETAILS, PLEASE CONSULT YOUR BANK)": "(POUR PLUS DE DÉTAILS, VEUILLEZ CONSULTER VOTRE BANQUE)",
    "Register Now": "Inscrivez-Vous",
    "Learn More": "En Savoir Plus",
    "Sandos4u Benefits": "Avantages de Sandos4u",
    "Date of birth": "Date de naissance",
    "All nature experience": "All nature experience"
  },
}
